export const kuwaitAreas = [
  {
    label: "Farwaniya",
    name: "Farwaniya",
    type: "group",
    options: [
      { label: "Abdullah Al-Mubarak - West Jeleeb", value: 78 },
      { label: "Airport", value: 86 },
      { label: "Andalous", value: 65 },
      { label: "Ardhiya", value: 62 },
      { label: "Ardhiya 4", value: 6858 },
      { label: "Ardiya Small Industrial", value: 87 },
      { label: "Ardiya Storage Zone", value: 88 },
      { label: "Ashbeliah", value: 77 },
      { label: "Dhajeej", value: 91 },
      { label: "Farwaniya", value: 6 },
      { label: "Ferdous", value: 61 },
      { label: "Jeleeb Al-Shuyoukh", value: 64 },
      { label: "Khaitan", value: 16 },
      { label: "Omariya", value: 17 },
      { label: "Rabiya", value: 18 },
      { label: "Rai", value: 76 },
      { label: "Reggai", value: 8 },
      { label: "Rehab", value: 19 },
      { label: "Sabah Al-Nasser", value: 63 },
      { label: "Sheikh Saad Al Abdullah Airport", value: 97 }
    ],
    value: 0
  },
  {
    label: "Kuwait City (Capital)",
    name: "Kuwait City (Capital)",
    type: "group",
    options: [
      { label: "Abdullah Al-Salem", value: 20 },
      { label: "Adailiya", value: 27 },
      { label: "Bneid Al Qar", value: 46 },
      { label: "Daiya", value: 35 },
      { label: "Dasma", value: 45 },
      { label: "Dasman", value: 49 },
      { label: "Doha", value: 47 },
      { label: "Faiha", value: 14 },
      { label: "Ghornata", value: 53 },
      { label: "Jaber Al Ahmad", value: 2048 },
      { label: "Kaifan", value: 10 },
      { label: "Khaldiya", value: 12 },
      { label: "Kuwait City", value: 4 },
      { label: "Mansouriya", value: 21 },
      { label: "Mirqab", value: 52 },
      { label: "Mubarakiya Camps", value: 84 },
      { label: "Nahda", value: 892 },
      { label: "North West Sulaibikhat", value: 5723 },
      { label: "Nuzha", value: 26 },
      { label: "Qadsiya", value: 25 },
      { label: "Qibla", value: 50 },
      { label: "Qortuba", value: 43 },
      { label: "Rawda", value: 22 },
      { label: "Salhiya", value: 51 },
      { label: "Shamiya", value: 13 },
      { label: "Sharq", value: 48 },
      { label: "Shuwaikh Administrative", value: 5715 },
      { label: "Shuwaikh Educational", value: 5719 },
      { label: "Shuwaikh Industrial 1", value: 5716 },
      { label: "Shuwaikh Industrial 2", value: 5717 },
      { label: "Shuwaikh Industrial 3", value: 5718 },
      { label: "Shuwaikh Medical", value: 5720 },
      { label: "Shuwaikh Residential", value: 5714 },
      { label: "Sulaibikhat", value: 54 },
      { label: "Surra", value: 42 },
      { label: "Yarmouk", value: 44 }
    ],
    value: 1
  },
  {
    name: "Mubarak Al-kabir",
    label: "Mubarak Al-kabir",
    type: "group",
    options: [
      { label: "Abu Ftaira", value: 80 },
      { label: "Abu Hasaniya", value: 108 },
      { label: "Adan", value: 41 },
      { label: "Al Masayel", value: 2047 },
      { label: "Al-Qurain", value: 56 },
      { label: "Al-Qusour", value: 57 },
      { label: "Fnaitess", value: 81 },
      { label: "Messila", value: 55 },
      { label: "Mubarak Al-Kabir", value: 58 },
      { label: "Sabah Al-Salem", value: 40 },
      { label: "Sabhan Industrial", value: 109 },
      { label: "South Wista", value: 105 },
      { label: "West Abu Fetera Small Indust", value: 106 },
      { label: "Wista", value: 107 }
    ],
    value: 2
  },
  {
    label: "Ahmadi",
    name: "Ahmadi",
    type: "group",
    options: [
      { label: "Abu Halifa", value: 2 },
      { label: "Al-Ahmadi", value: 3 },
      { label: "Ali Sabah Al-Salem - Umm Al Hayman", value: 82 },
      { label: "Al-Julaia'a", value: 6860 },
      { label: "Bnaider", value: 6650 },
      { label: "Dhaher", value: 59 },
      { label: "Egaila", value: 79 },
      { label: "Fahad Al Ahmed", value: 98 },
      { label: "Fahaheel", value: 5 },
      { label: "Fintas", value: 38 },
      { label: "Hadiya", value: 30 },
      { label: "Jaber Al Ali", value: 60 },
      { label: "Khairan", value: 2726 },
      { label: "Magwa", value: 99 },
      { label: "Mahboula", value: 24 },
      { label: "Mangaf", value: 32 },
      { label: "Mina Abdullah", value: 100 },
      { label: "Nuwaiseeb", value: 2054 },
      { label: "Riqqa", value: 37 },
      { label: "Sabah Al Ahmad Marine City", value: 2055 },
      { label: "Sabah AL Ahmad residential", value: 2056 },
      { label: "Sabahiya", value: 31 },
      { label: "Shuaiba Port", value: 103 },
      { label: "South Sabahiya", value: 6864 },
      { label: "Wafra farms", value: 2057 },
      { label: "Wafra residential", value: 2058 },
      { label: "Zour", value: 2053 }
    ],
    value: 3
  },
  {
    label: "Hawally",
    name: "Hawally",
    type: "group",
    options: [
      { label: "Al-Bedae", value: 74 },
      { label: "Bayan", value: 36 },
      { label: "Hawally", value: 7 },
      { label: "Hitteen", value: 72 },
      { label: "Jabriya", value: 23 },
      { label: "Maidan Hawally", value: 33 },
      { label: "Ministries Zone", value: 6859 },
      { label: "Mishrif", value: 29 },
      { label: "Mubarak Al-Abdullah - West Mishref", value: 70 },
      { label: "Rumaithiya", value: 28 },
      { label: "Salam", value: 73 },
      { label: "Salmiya", value: 9 },
      { label: "Salwa", value: 39 },
      { label: "Shaab", value: 34 },
      { label: "Shuhada", value: 71 },
      { label: "Siddiq", value: 75 },
      { label: "Zahra", value: 69 }
    ],
    value: 4
  },
  {
    label: "Al Jahra",
    name: "Al Jahra",
    type: "group",
    options: [
      { label: "Al Naeem", value: 2049 },
      { label: "Amgarah Industrial", value: 2050 },
      { label: "Jahra Area", value: 11 },
      { label: "Kabd", value: 2051 },
      { label: "Nasseem", value: 66 },
      { label: "Oyoun", value: 68 },
      { label: "Qasr", value: 93 },
      { label: "Saad Al Abdullah", value: 1859 },
      { label: "Sulaibiya", value: 83 },
      { label: "Sulaibiya Industrial 1", value: 94 },
      { label: "Sulaibiya Industrial 2", value: 95 },
      { label: "Sulaibiya Residential", value: 96 },
      { label: "Taima", value: 2052 },
      { label: "Waha", value: 67 },
      { label: "Jahra Qairawan - South Doha", value: 92 }
    ],
    value: 5
  }
];

const ksaAreas = [
  {
    label: "Hautat Sudair",
    name: "Hautat Sudair",
    type: "group",
    options: [
      {
        label: "Hautat Sudair",
        value: 6862
      }
    ],
    value: 0
  },
  {
    label: "Khafji",
    name: "Khafji",
    type: "group",
    options: [
      {
        label: "​Aramco housing",
        value: 5236
      },
      {
        label: "Al Aziziyah",
        value: 5290
      },
      {
        label: "Al Faihaa",
        value: 6010
      },
      {
        label: "Al Faisaliyyah",
        value: 5286
      },
      {
        label: "Al Hamra",
        value: 6011
      },
      {
        label: "Al Jawhara",
        value: 5287
      },
      {
        label: "Al Khalidiyah",
        value: 5283
      },
      {
        label: "Al khalij",
        value: 5235
      },
      {
        label: "Al Luluah",
        value: 5281
      },
      {
        label: "Al Moruj",
        value: 6006
      },
      {
        label: "Al Muhammadiyah",
        value: 3613
      },
      {
        label: "Al Nahda",
        value: 6197
      },
      {
        label: "Al Rawdah",
        value: 5284
      },
      {
        label: "Al Rayan",
        value: 5288
      },
      {
        label: "Al Salam",
        value: 6007
      },
      {
        label: "Al Taawn",
        value: 6009
      },
      {
        label: "Al Yarmouk",
        value: 6008
      },
      {
        label: "Al Yasmine",
        value: 6016
      },
      {
        label: "Aramco",
        value: 2958
      },
      {
        label: "Industrial Area 1",
        value: 6012
      },
      {
        label: "Industrial Area 2",
        value: 3610
      },
      {
        label: "Internal Security Forces",
        value: 6013
      },
      {
        label: "Khafji Industrial Area",
        value: 6014
      },
      {
        label: "King Fahad",
        value: 6015
      }
    ],
    value: 1
  },
  {
    label: "Dammam",
    name: "Dammam",
    type: "group",
    options: [
      {
        label: "Abdullah Fuad",
        value: 1620
      },
      {
        label: "Al Adamah",
        value: 4296
      },
      {
        label: "Al Amal",
        value: 270
      },
      {
        label: "Al Amamrah",
        value: 298
      },
      {
        label: "Al Amanah",
        value: 6002
      },
      {
        label: "Al Amir Muhammed Ibn Saud\t",
        value: 6005
      },
      {
        label: "Al Anood",
        value: 4355
      },
      {
        label: "Al Anwaar",
        value: 5998
      },
      {
        label: "Al Athir",
        value: 1609
      },
      {
        label: "Al Aziziyah",
        value: 297
      },
      {
        label: "Al Badea",
        value: 1783
      },
      {
        label: "Al Badiyah",
        value: 272
      },
      {
        label: "Al Basatin",
        value: 273
      },
      {
        label: "Al Buhayrah",
        value: 5997
      },
      {
        label: "Al Dabab",
        value: 295
      },
      {
        label: "Al Danah",
        value: 282
      },
      {
        label: "Al Dawasir",
        value: 283
      },
      {
        label: "Al Etisalat",
        value: 268
      },
      {
        label: "Al Faiha",
        value: 302
      },
      {
        label: "Al Faisaliyah",
        value: 303
      },
      {
        label: "Al Fanar",
        value: 5999
      },
      {
        label: "Al Firdaws",
        value: 301
      },
      {
        label: "Al Fursan",
        value: 4409
      },
      {
        label: "Al Hadabah",
        value: 6003
      },
      {
        label: "Al Hamra",
        value: 279
      },
      {
        label: "Al Hussam",
        value: 1781
      },
      {
        label: "Al Jalawiyah",
        value: 277
      },
      {
        label: "Al Jamiyin",
        value: 276
      },
      {
        label: "Al Jawharah",
        value: 4377
      },
      {
        label: "Al Khalidiyah Al Janubiyah",
        value: 1789
      },
      {
        label: "Al Khalidiyah Al Shamaliyah",
        value: 1788
      },
      {
        label: "Al Khalij",
        value: 281
      },
      {
        label: "Al Khodaryah",
        value: 1779
      },
      {
        label: "Al Manar",
        value: 1606
      },
      {
        label: "Al Matar",
        value: 5995
      },
      {
        label: "Al Mazruiyah",
        value: 415
      },
      {
        label: "Al Muhammadiyah",
        value: 306
      },
      {
        label: "Al Muraikabat",
        value: 4089
      },
      {
        label: "Al Nada",
        value: 1782
      },
      {
        label: "Al Nahdah",
        value: 319
      },
      {
        label: "Al Nakhil",
        value: 315
      },
      {
        label: "Al Nasriyah",
        value: 4517
      },
      {
        label: "Al Nawras",
        value: 321
      },
      {
        label: "Al Nour",
        value: 4099
      },
      {
        label: "Al Nuzhah",
        value: 317
      },
      {
        label: "Al Qadisiyah",
        value: 1780
      },
      {
        label: "Al Qazaz",
        value: 305
      },
      {
        label: "Al Rabea",
        value: 416
      },
      {
        label: "Al Rabiyah",
        value: 613
      },
      {
        label: "Al Rakah Al Shamaliyah",
        value: 6001
      },
      {
        label: "Al Rawdah",
        value: 4040
      },
      {
        label: "Al Rayyan",
        value: 1614
      },
      {
        label: "Al Sadafah",
        value: 5299
      },
      {
        label: "Al Safa",
        value: 4120
      },
      {
        label: "Al Saif",
        value: 289
      },
      {
        label: "Al Salam",
        value: 4323
      },
      {
        label: "Al Sharq",
        value: 6004
      },
      {
        label: "Al Shati Al Gharbi",
        value: 1849
      },
      {
        label: "Al Shati Ash Sharqi",
        value: 1848
      },
      {
        label: "Al Shulah",
        value: 1607
      },
      {
        label: "Al Souq",
        value: 1784
      },
      {
        label: "Al Tubayshi",
        value: 414
      },
      {
        label: "Al Wahah",
        value: 4378
      },
      {
        label: "Al Zuhur",
        value: 287
      },
      {
        label: "Badr",
        value: 2654
      },
      {
        label: "Dahiyat Al Malik Fahad",
        value: 324
      },
      {
        label: "Dammam 2nd Industrial City",
        value: 308
      },
      {
        label: "Dammam University",
        value: 6469
      },
      {
        label: "Ghirnatah",
        value: 326
      },
      {
        label: "Ibn Khaldoon",
        value: 266
      },
      {
        label: "Imam Abdulrahman Bin Faisal University",
        value: 6000
      },
      {
        label: "Industrial",
        value: 312
      },
      {
        label: "Industrial Area No 1",
        value: 4518
      },
      {
        label: "Iskan Dammam",
        value: 1619
      },
      {
        label: "King Fahd International Airport",
        value: 4519
      },
      {
        label: "King Fahd University",
        value: 4079
      },
      {
        label: "King Saud St",
        value: 6882
      },
      {
        label: "Madinat Al Ummal",
        value: 1622
      },
      {
        label: "Muntazah",
        value: 311
      },
      {
        label: "Nahda",
        value: 3313
      },
      {
        label: "Qasr Al Khaleej",
        value: 5996
      },
      {
        label: "Taybah",
        value: 325
      },
      {
        label: "Uhud",
        value: 267
      }
    ],
    value: 2
  },
  {
    label: "Abha",
    name: "Abha",
    type: "group",
    options: [
      {
        label: "Abha Al Jadidah",
        value: 2172
      },
      {
        label: "Al Andalus",
        value: 2075
      },
      {
        label: "Al Arin",
        value: 5724
      },
      {
        label: "Al Badea",
        value: 6337
      },
      {
        label: "Al Dabab",
        value: 2071
      },
      {
        label: "Al Faisaliyah",
        value: 2852
      },
      {
        label: "Al Khalidiyah",
        value: 2067
      },
      {
        label: "Al Khashaa",
        value: 5726
      },
      {
        label: "Al Manhal",
        value: 2076
      },
      {
        label: "Al Mansak",
        value: 2066
      },
      {
        label: "Al Morug",
        value: 5727
      },
      {
        label: "AL Mozafen",
        value: 2854
      },
      {
        label: "Al Muftaha",
        value: 2080
      },
      {
        label: "Al Nasab",
        value: 2078
      },
      {
        label: "Al Nasim",
        value: 5730
      },
      {
        label: "Al Nuzhah",
        value: 2073
      },
      {
        label: "Al Qabil",
        value: 2068
      },
      {
        label: "Al Qora",
        value: 4072
      },
      {
        label: "Al Rabwah",
        value: 3393
      },
      {
        label: "Al Sadd",
        value: 3394
      },
      {
        label: "Al Sarawat",
        value: 5732
      },
      {
        label: "Al Sharafiyah",
        value: 5739
      },
      {
        label: "Al Shifa",
        value: 4073
      },
      {
        label: "Al Tabjiah",
        value: 4262
      },
      {
        label: "Al Wardatain",
        value: 2079
      },
      {
        label: "Al Wasayif",
        value: 3395
      },
      {
        label: "Downtown",
        value: 5742
      },
      {
        label: "Durat Al Mansak",
        value: 5744
      },
      {
        label: "Hey Al Jamaah",
        value: 6336
      },
      {
        label: "Shamasan",
        value: 2077
      },
      {
        label: "Thirah",
        value: 3398
      }
    ],
    value: 3
  },
  {
    label: "Jeddah",
    name: "Jeddah",
    type: "group",
    options: [
      {
        label: "Abruq Al Rughamah",
        value: 334
      },
      {
        label: "Al Adel",
        value: 584
      },
      {
        label: "Al Ajaweed",
        value: 3085
      },
      {
        label: "Al Ajwad",
        value: 335
      },
      {
        label: "Al Amir Fawaz Al Janouby",
        value: 5713
      },
      {
        label: "Al Amir Fawaz Al Shamaly",
        value: 5712
      },
      {
        label: "Al Ammariyah",
        value: 368
      },
      {
        label: "Al Ammwaj",
        value: 5203
      },
      {
        label: "Al Andalus",
        value: 339
      },
      {
        label: "Al Asalah",
        value: 4533
      },
      {
        label: "Al Aziziyah",
        value: 367
      },
      {
        label: "Al Baghdadiyah Al Gharbiyah",
        value: 342
      },
      {
        label: "Al Baghdadiyah Al Sharqiyah",
        value: 4522
      },
      {
        label: "Al Balad",
        value: 343
      },
      {
        label: "Al Barakah",
        value: 5697
      },
      {
        label: "Al Basateen",
        value: 340
      },
      {
        label: "Al Bashaer",
        value: 5196
      },
      {
        label: "Al Bawadi",
        value: 344
      },
      {
        label: "Al Dahiah",
        value: 5701
      },
      {
        label: "Al Fadelah",
        value: 5700
      },
      {
        label: "Al Faiha",
        value: 371
      },
      {
        label: "Al Faisaliyah",
        value: 372
      },
      {
        label: "Al Falah",
        value: 5058
      },
      {
        label: "Al Farouq",
        value: 5992
      },
      {
        label: "Al Ferdous",
        value: 5200
      },
      {
        label: "Al Frosyah",
        value: 2799
      },
      {
        label: "Al Hamadaniyah",
        value: 398
      },
      {
        label: "Al Hamraa",
        value: 349
      },
      {
        label: "Al Hindaweyah",
        value: 388
      },
      {
        label: "Al Jamaa",
        value: 348
      },
      {
        label: "Al Jawharah",
        value: 395
      },
      {
        label: "Al Kandarah",
        value: 374
      },
      {
        label: "Al Kawthar",
        value: 5158
      },
      {
        label: "Al Khalidiyah",
        value: 350
      },
      {
        label: "Al Khomrah",
        value: 5054
      },
      {
        label: "Al Loaloa",
        value: 5202
      },
      {
        label: "Al Mahjar",
        value: 376
      },
      {
        label: "Al Manar",
        value: 408
      },
      {
        label: "Al Marwah",
        value: 379
      },
      {
        label: "Al Masarah",
        value: 5699
      },
      {
        label: "Al Mohammadiyah",
        value: 377
      },
      {
        label: "Al Montazah",
        value: 5990
      },
      {
        label: "Al Moulysaa",
        value: 5982
      },
      {
        label: "Al Muntazahat",
        value: 2818
      },
      {
        label: "Al Murjan",
        value: 3548
      },
      {
        label: "Al Nahdah",
        value: 387
      },
      {
        label: "Al Naim",
        value: 386
      },
      {
        label: "Al Nakheel",
        value: 583
      },
      {
        label: "Al Naseem",
        value: 385
      },
      {
        label: "Al Naseem 1",
        value: 5869
      },
      {
        label: "Al Nazlah Al Sharqiyah",
        value: 382
      },
      {
        label: "Al Nazlah Al Yamaniyah",
        value: 383
      },
      {
        label: "Al Nuzhah",
        value: 384
      },
      {
        label: "Al Qouzeen",
        value: 5993
      },
      {
        label: "Al Qurayat",
        value: 373
      },
      {
        label: "Al Quryniah",
        value: 5696
      },
      {
        label: "Al Rabwah",
        value: 351
      },
      {
        label: "Al Rahmanyah",
        value: 4695
      },
      {
        label: "Al Rawabi",
        value: 354
      },
      {
        label: "Al Rawdah",
        value: 355
      },
      {
        label: "Al Rayaan",
        value: 5159
      },
      {
        label: "Al Rehab",
        value: 353
      },
      {
        label: "Al Riyadh",
        value: 5233
      },
      {
        label: "Al Ruwais",
        value: 356
      },
      {
        label: "Al Sabeel",
        value: 359
      },
      {
        label: "Al Safa",
        value: 366
      },
      {
        label: "Al Sahifah",
        value: 365
      },
      {
        label: "Al Sahil",
        value: 5055
      },
      {
        label: "Al Salamah",
        value: 361
      },
      {
        label: "Al Salehiyah",
        value: 2802
      },
      {
        label: "Al Samer",
        value: 358
      },
      {
        label: "Al Sanabel",
        value: 2218
      },
      {
        label: "Al Sarawat",
        value: 5988
      },
      {
        label: "Al Sawari",
        value: 3094
      },
      {
        label: "Al Sharafeyah",
        value: 364
      },
      {
        label: "Al Shati",
        value: 1168
      },
      {
        label: "Al Sheraa",
        value: 5133
      },
      {
        label: "Al Shorouq",
        value: 5705
      },
      {
        label: "Al Sororyah",
        value: 5056
      },
      {
        label: "Al Sulaymaniyah",
        value: 362
      },
      {
        label: "Al Taawon",
        value: 5703
      },
      {
        label: "Al Thaalibah",
        value: 346
      },
      {
        label: "Al Thaghr",
        value: 347
      },
      {
        label: "Al Wadi",
        value: 5986
      },
      {
        label: "Al Wahah",
        value: 2813
      },
      {
        label: "Al Wazeeriyah",
        value: 390
      },
      {
        label: "Al Woroud",
        value: 389
      },
      {
        label: "Al Yaqout",
        value: 4535
      },
      {
        label: "Al Zahrah",
        value: 357
      },
      {
        label: "Al Zumorod",
        value: 5201
      },
      {
        label: "Bahrah",
        value: 6344
      },
      {
        label: "Bani Malik",
        value: 4540
      },
      {
        label: "Bryman",
        value: 393
      },
      {
        label: "Ghulail",
        value: 370
      },
      {
        label: "Industrial Area",
        value: 381
      },
      {
        label: "Jawharah Staduim",
        value: 5994
      },
      {
        label: "Jeddah Islamic Seaport",
        value: 5063
      },
      {
        label: "King Abdul Aziz University",
        value: 5707
      },
      {
        label: "King Abdulaziz International Airport",
        value: 405
      },
      {
        label: "King Abdulaziz Medical City",
        value: 4528
      },
      {
        label: "King Abdullah University\t",
        value: 6345
      },
      {
        label: "King Faisal Naval Base",
        value: 5980
      },
      {
        label: "Madain Al Fahad",
        value: 401
      },
      {
        label: "Mushrifah",
        value: 404
      },
      {
        label: "Obhur Al Janoubyah",
        value: 5711
      },
      {
        label: "Obhur AlShamalyah",
        value: 5710
      },
      {
        label: "Petromin",
        value: 392
      },
      {
        label: "Prince Abdulmajeed",
        value: 4526
      },
      {
        label: "Taibah",
        value: 5094
      },
      {
        label: "Thuwal",
        value: 6346
      },
      {
        label: "Umm Al Salm",
        value: 5059
      }
    ],
    value: 4
  },
  {
    label: "Al Madinah Al Munawwarah",
    name: "Al Madinah Al Munawwarah",
    type: "group",
    options: [
      {
        label: "Abu Burayqa",
        value: 6136
      },
      {
        label: "Abu Kabir",
        value: 6087
      },
      {
        label: "Al Anabis",
        value: 2269
      },
      {
        label: "Al Aridh",
        value: 6113
      },
      {
        label: "Al Barakah",
        value: 3081
      },
      {
        label: "Al Dar",
        value: 6114
      },
      {
        label: "Al Dhahirah",
        value: 6088
      },
      {
        label: "Al Difaa",
        value: 6084
      },
      {
        label: "Al Duwaikhilah",
        value: 2265
      },
      {
        label: "Al Duwaimah",
        value: 5454
      },
      {
        label: "Al Fath",
        value: 6103
      },
      {
        label: "Al Ghabah",
        value: 6097
      },
      {
        label: "Al Gharra",
        value: 6086
      },
      {
        label: "Al Hadiqah",
        value: 6101
      },
      {
        label: "Al Hadra",
        value: 6115
      },
      {
        label: "Al Hafya",
        value: 6109
      },
      {
        label: "Al Haram Al Nabwy",
        value: 6091
      },
      {
        label: "Al Ihn",
        value: 6089
      },
      {
        label: "Al Iskan",
        value: 2231
      },
      {
        label: "Al Jabirah",
        value: 5462
      },
      {
        label: "Al Jamawat",
        value: 6122
      },
      {
        label: "Al Jassah",
        value: 6116
      },
      {
        label: "Al Jumuah",
        value: 2235
      },
      {
        label: "Al Khalidiyyah",
        value: 2230
      },
      {
        label: "Al Khatim",
        value: 6123
      },
      {
        label: "Al Mabooth",
        value: 6117
      },
      {
        label: "Al Manakhah",
        value: 6124
      },
      {
        label: "Al Masanee",
        value: 2229
      },
      {
        label: "Al Matar",
        value: 2232
      },
      {
        label: "Al Mughaisilah",
        value: 6099
      },
      {
        label: "Al Nakhil",
        value: 6137
      },
      {
        label: "Al Naqaa",
        value: 6128
      },
      {
        label: "Al Naqs",
        value: 6118
      },
      {
        label: "Al Oyoun",
        value: 2226
      },
      {
        label: "Al Qaswaa",
        value: 5458
      },
      {
        label: "Al Qiblatayn",
        value: 6093
      },
      {
        label: "Al Ranuna",
        value: 6090
      },
      {
        label: "Al Rawabi",
        value: 2240
      },
      {
        label: "Al Rayah",
        value: 6129
      },
      {
        label: "Al Rummanah",
        value: 6108
      },
      {
        label: "Al Sad",
        value: 6107
      },
      {
        label: "Al Sadiqiyyah",
        value: 6102
      },
      {
        label: "Al Sakb",
        value: 6104
      },
      {
        label: "Al Salam",
        value: 2273
      },
      {
        label: "Al Shahbaa",
        value: 6139
      },
      {
        label: "Al Shuraybat",
        value: 5463
      },
      {
        label: "Al Sih",
        value: 4273
      },
      {
        label: "AL Sikkah Al Hadid",
        value: 6100
      },
      {
        label: "Al Suqya",
        value: 6106
      },
      {
        label: "Al Talah",
        value: 6110
      },
      {
        label: "Al Usayfirin",
        value: 6092
      },
      {
        label: "Al Usbah",
        value: 5453
      },
      {
        label: "Al Wabra",
        value: 2247
      },
      {
        label: "Al Zahrah",
        value: 6138
      },
      {
        label: "Alaziziyah",
        value: 2258
      },
      {
        label: "Ayn Al Khif",
        value: 6119
      },
      {
        label: "Badaah",
        value: 6120
      },
      {
        label: "Bani Abdul Al Ashhal",
        value: 6131
      },
      {
        label: "Bani Bayadah",
        value: 6135
      },
      {
        label: "Bani Dhafar",
        value: 6094
      },
      {
        label: "Bani Harithah",
        value: 2228
      },
      {
        label: "Bani Khidrah",
        value: 6132
      },
      {
        label: "Bani Muawiyah",
        value: 2227
      },
      {
        label: "Bir Uthman",
        value: 3080
      },
      {
        label: "Dhu Al Hulayfah",
        value: 6105
      },
      {
        label: "Hathm",
        value: 6125
      },
      {
        label: "Islamic University of Madinah",
        value: 2834
      },
      {
        label: "Jabal Ayr",
        value: 6095
      },
      {
        label: "Jabal Ghammah we Ghurabah",
        value: 6083
      },
      {
        label: "Jabal Uhud",
        value: 6096
      },
      {
        label: "Khakh",
        value: 6140
      },
      {
        label: "King Fahad",
        value: 5576
      },
      {
        label: "Kittanah",
        value: 6098
      },
      {
        label: "Mahzoor",
        value: 6112
      },
      {
        label: "Masjid Al Dara",
        value: 6133
      },
      {
        label: "MasjidWairah",
        value: 6134
      },
      {
        label: "Mudhainib",
        value: 6127
      },
      {
        label: "Nubalaa",
        value: 6126
      },
      {
        label: "Qalat Makhit",
        value: 6085
      },
      {
        label: "Qurban",
        value: 2234
      },
      {
        label: "Rahat",
        value: 6130
      },
      {
        label: "Sayed Al Shuhada",
        value: 2245
      },
      {
        label: "Shadhah",
        value: 2243
      },
      {
        label: "Shuran",
        value: 2275
      },
      {
        label: "Tayba",
        value: 2274
      },
      {
        label: "Umm Khalid",
        value: 6111
      },
      {
        label: "Urwah",
        value: 2267
      },
      {
        label: "Warqan",
        value: 6121
      }
    ],
    value: 5
  },
  {
    label: "Safwa",
    name: "Safwa",
    type: "group",
    options: [
      {
        label: "Abu Maan",
        value: 2988
      },
      {
        label: "Al Awjam",
        value: 5384
      },
      {
        label: "Al Bodur",
        value: 5383
      },
      {
        label: "Al Duraydi",
        value: 5380
      },
      {
        label: "Al Marwa",
        value: 5369
      },
      {
        label: "Al Masif",
        value: 5375
      },
      {
        label: "Al Nahdah",
        value: 5373
      },
      {
        label: "Al Oroba",
        value: 5367
      },
      {
        label: "Al Rabwah",
        value: 5371
      },
      {
        label: "Al Raihan",
        value: 6189
      },
      {
        label: "Al Rihab",
        value: 5379
      },
      {
        label: "Al Ruwaihah",
        value: 5377
      },
      {
        label: "Al-Telal",
        value: 5382
      },
      {
        label: "Hazim",
        value: 6188
      },
      {
        label: "Om Al Sahik",
        value: 2996
      },
      {
        label: "Safa",
        value: 5370
      },
      {
        label: "Safwa",
        value: 2947
      }
    ],
    value: 6
  },
  {
    label: "Hafar Al Batin",
    name: "Hafar Al Batin",
    type: "group",
    options: [
      {
        label: "Abu Musa Al Ashari",
        value: 2977
      },
      {
        label: "Al Aziziyah",
        value: 2978
      },
      {
        label: "Al Baladiyah",
        value: 2986
      },
      {
        label: "Al Batin",
        value: 3276
      },
      {
        label: "Al Faiha",
        value: 4042
      },
      {
        label: "Al Faisaliyah",
        value: 2983
      },
      {
        label: "Al Iskan",
        value: 2982
      },
      {
        label: "Al Jamaa",
        value: 6072
      },
      {
        label: "Al Khalidiyah",
        value: 2984
      },
      {
        label: "Al Manar",
        value: 6073
      },
      {
        label: "Al Masif",
        value: 4041
      },
      {
        label: "Al Muhammadiyah",
        value: 2985
      },
      {
        label: "Al Muruj",
        value: 3278
      },
      {
        label: "Al Nahdah",
        value: 3011
      },
      {
        label: "Al Nakhil",
        value: 4595
      },
      {
        label: "Al Nayfiyah",
        value: 3279
      },
      {
        label: "Al Nuzhah",
        value: 3013
      },
      {
        label: "Al Rabea",
        value: 6076
      },
      {
        label: "Al Rabiyah",
        value: 6077
      },
      {
        label: "Al Raid",
        value: 6078
      },
      {
        label: "Al Rawdah",
        value: 6473
      },
      {
        label: "Al Rayan",
        value: 3281
      },
      {
        label: "Al Safa",
        value: 3014
      },
      {
        label: "Al Shifa",
        value: 4593
      },
      {
        label: "Al Sulimaniyah",
        value: 3282
      },
      {
        label: "Al Tilal",
        value: 3285
      },
      {
        label: "Al Wadi",
        value: 3012
      },
      {
        label: "Al Wahah",
        value: 3275
      },
      {
        label: "Al Worud",
        value: 6074
      },
      {
        label: "Al Yarmuk",
        value: 6075
      },
      {
        label: "Alqasiuma",
        value: 4596
      },
      {
        label: "Fulaij",
        value: 6080
      },
      {
        label: "Ghirnatah",
        value: 6081
      },
      {
        label: "Industrial Area",
        value: 6079
      },
      {
        label: "Qurtubah",
        value: 6082
      },
      {
        label: "RABWA",
        value: 2980
      }
    ],
    value: 7
  },
  {
    label: "Tabuk",
    name: "Tabuk",
    type: "group",
    options: [
      {
        label: "Abu Sabaa",
        value: 2865
      },
      {
        label: "Al Ain",
        value: 6242
      },
      {
        label: "Al Aziziyah Al Jadidah New",
        value: 5479
      },
      {
        label: "Al Aziziyah Al Qadimah Old",
        value: 5266
      },
      {
        label: "Al Bawadi",
        value: 3089
      },
      {
        label: "Al Faisaliyah Al Janubiyah",
        value: 6246
      },
      {
        label: "Al Faisaliyah Al Shamaliyah",
        value: 6247
      },
      {
        label: "Al Hudaibah",
        value: 5265
      },
      {
        label: "Al Khalidiyah",
        value: 4266
      },
      {
        label: "Al Mahrajan",
        value: 5269
      },
      {
        label: "Al Manshiah",
        value: 5270
      },
      {
        label: "Al Masif",
        value: 3087
      },
      {
        label: "Al Muntazah",
        value: 4265
      },
      {
        label: "Al Muruj",
        value: 3423
      },
      {
        label: "Al Muruj - B",
        value: 3424
      },
      {
        label: "Al Nahdah",
        value: 3427
      },
      {
        label: "Al Nakhil",
        value: 6248
      },
      {
        label: "Al Olaya",
        value: 3428
      },
      {
        label: "Al Qadsiah 1",
        value: 3432
      },
      {
        label: "Al Qadsiah 2",
        value: 3433
      },
      {
        label: "Al Quds",
        value: 6249
      },
      {
        label: "Al Rabiyah -Al Rayan",
        value: 6255
      },
      {
        label: "Al Rajhay",
        value: 2868
      },
      {
        label: "Al Rawdah",
        value: 5473
      },
      {
        label: "Al Saadah",
        value: 5272
      },
      {
        label: "Al Safa",
        value: 6250
      },
      {
        label: "Al Salam",
        value: 5268
      },
      {
        label: "Al Salihiyah",
        value: 5474
      },
      {
        label: "Al Sheikh",
        value: 5277
      },
      {
        label: "Al Sulimaniyah",
        value: 3435
      },
      {
        label: "Al Wurud",
        value: 3438
      },
      {
        label: "Al Yarmouk",
        value: 6252
      },
      {
        label: "Albasatin",
        value: 6245
      },
      {
        label: "Industrial Area",
        value: 6258
      },
      {
        label: "Karim",
        value: 5278
      },
      {
        label: "Military Area",
        value: 3090
      },
      {
        label: "Muruj Al Amir",
        value: 3422
      },
      {
        label: "New industrial zone",
        value: 6253
      },
      {
        label: "Qurtobah",
        value: 5267
      },
      {
        label: "Raheel",
        value: 5274
      },
      {
        label: "Salman - Al Faisaliyah Al Janubiyah",
        value: 4268
      },
      {
        label: "Sultanah",
        value: 3436
      },
      {
        label: "Tabuk Airport",
        value: 5475
      }
    ],
    value: 8
  },
  {
    label: "Al Majmaah",
    name: "Al Majmaah",
    type: "group",
    options: [
      {
        label: "Academic City",
        value: 5819
      },
      {
        label: "Al Andalus",
        value: 5820
      },
      {
        label: "Al Faiha",
        value: 3470
      },
      {
        label: "Al Jameyeen",
        value: 2917
      },
      {
        label: "Al Marqab",
        value: 2916
      },
      {
        label: "Al Matar",
        value: 3474
      },
      {
        label: "Al Muruj",
        value: 5821
      },
      {
        label: "Al Mustaqbal",
        value: 5822
      },
      {
        label: "Al Rawdah",
        value: 3477
      },
      {
        label: "Al Yarmuk",
        value: 3479
      },
      {
        label: "Industrial Area",
        value: 2918
      },
      {
        label: "King Abdulaziz",
        value: 2919
      },
      {
        label: "King Abdullah",
        value: 3472
      },
      {
        label: "King Fahad",
        value: 3471
      },
      {
        label: "King Salman",
        value: 3475
      }
    ],
    value: 9
  },
  {
    label: "Riyadh",
    name: "Riyadh",
    type: "group",
    options: [
      {
        label: "Ad Difa",
        value: 5468
      },
      {
        label: "Al Ammal",
        value: 171
      },
      {
        label: "Al Andalus",
        value: 114
      },
      {
        label: "Al Aqiq",
        value: 169
      },
      {
        label: "Al Arid",
        value: 5676
      },
      {
        label: "Al Awali",
        value: 5195
      },
      {
        label: "Al Aziziyah",
        value: 168
      },
      {
        label: "Al Badi'ah",
        value: 116
      },
      {
        label: "Al Bariah",
        value: 5679
      },
      {
        label: "Al Batha",
        value: 117
      },
      {
        label: "Al Bujairi - Al Diriyah",
        value: 5687
      },
      {
        label: "Al Dar Al Baida",
        value: 4671
      },
      {
        label: "AL Dhubbat",
        value: 161
      },
      {
        label: "Al Dirah",
        value: 133
      },
      {
        label: "Al Diriyah",
        value: 128
      },
      {
        label: "Al Diriyah Al Jadidah - Al Diriyah",
        value: 5693
      },
      {
        label: "Al Dubiyah",
        value: 132
      },
      {
        label: "Al Duraihimiyah",
        value: 4184
      },
      {
        label: "Al Faiha",
        value: 177
      },
      {
        label: "Al Faisaliyah",
        value: 178
      },
      {
        label: "Al Faisaliyah - Al Diriyah",
        value: 5689
      },
      {
        label: "Al Fakhiriyah",
        value: 173
      },
      {
        label: "Al Falah",
        value: 175
      },
      {
        label: "Al Faruq",
        value: 4396
      },
      {
        label: "Al Futah",
        value: 176
      },
      {
        label: "Al Ghadir",
        value: 172
      },
      {
        label: "Al Ghnamiah",
        value: 5683
      },
      {
        label: "Al hada",
        value: 4131
      },
      {
        label: "Al Haeer",
        value: 4719
      },
      {
        label: "Al Hamra",
        value: 123
      },
      {
        label: "Al Hazm",
        value: 4673
      },
      {
        label: "Al Iskan",
        value: 113
      },
      {
        label: "Al Izdihar",
        value: 112
      },
      {
        label: "Al Janadriyah",
        value: 121
      },
      {
        label: "Al Jaradiyah",
        value: 119
      },
      {
        label: "Al Jazirah",
        value: 120
      },
      {
        label: "Al Jubaylah",
        value: 4559
      },
      {
        label: "Al Khaleej",
        value: 126
      },
      {
        label: "Al Khalidiyah",
        value: 124
      },
      {
        label: "Al Khalidiyah - Al Diriyah",
        value: 5691
      },
      {
        label: "Al Khuzama",
        value: 125
      },
      {
        label: "Al Maather",
        value: 4133
      },
      {
        label: "Al Mahdiyah",
        value: 4130
      },
      {
        label: "Al Maizilah",
        value: 198
      },
      {
        label: "Al Malaz",
        value: 200
      },
      {
        label: "Al Malqa",
        value: 201
      },
      {
        label: "Al Manakh",
        value: 202
      },
      {
        label: "Al Manar",
        value: 203
      },
      {
        label: "Al Mansorah",
        value: 411
      },
      {
        label: "Al Mansuriyah",
        value: 890
      },
      {
        label: "Al Mareh - Al Diriyah",
        value: 5686
      },
      {
        label: "Al Marqab",
        value: 188
      },
      {
        label: "Al Marwah",
        value: 4185
      },
      {
        label: "Al Masani",
        value: 192
      },
      {
        label: "Al Masiaf",
        value: 194
      },
      {
        label: "Al Mathar Al Shamali",
        value: 196
      },
      {
        label: "Al Misfat",
        value: 193
      },
      {
        label: "Al Mishaal",
        value: 4397
      },
      {
        label: "Al Moghrazat",
        value: 5125
      },
      {
        label: "Al Mohamadiyah",
        value: 184
      },
      {
        label: "Al Moqbel Palaces",
        value: 6143
      },
      {
        label: "Al Morsalat",
        value: 187
      },
      {
        label: "Al Munsiyah",
        value: 204
      },
      {
        label: "Al Murabba",
        value: 186
      },
      {
        label: "Al Muruj",
        value: 190
      },
      {
        label: "Al Mutamarat",
        value: 183
      },
      {
        label: "Al Nada",
        value: 207
      },
      {
        label: "Al Nadhim",
        value: 212
      },
      {
        label: "Al Nadwa",
        value: 5573
      },
      {
        label: "Al Nafal",
        value: 213
      },
      {
        label: "Al Nahdah",
        value: 215
      },
      {
        label: "Al Nakhil",
        value: 206
      },
      {
        label: "Al Namudhajiyah",
        value: 214
      },
      {
        label: "Al Narjis",
        value: 208
      },
      {
        label: "Al Nasim Al Gharbi",
        value: 211
      },
      {
        label: "Al Nasim Al Sharqi",
        value: 210
      },
      {
        label: "Al Nasriyah",
        value: 4134
      },
      {
        label: "Al Nur",
        value: 216
      },
      {
        label: "Al Nuzhah",
        value: 209
      },
      {
        label: "Al Olaya",
        value: 170
      },
      {
        label: "Al Oud",
        value: 889
      },
      {
        label: "Al Qadisiyah",
        value: 179
      },
      {
        label: "Al Qairawan",
        value: 182
      },
      {
        label: "Al Quds",
        value: 180
      },
      {
        label: "Al Qura",
        value: 6141
      },
      {
        label: "Al Rabi",
        value: 136
      },
      {
        label: "Al Rabwah",
        value: 135
      },
      {
        label: "Al Rafiah",
        value: 138
      },
      {
        label: "Al Rahmaniyah",
        value: 137
      },
      {
        label: "Al Raid",
        value: 134
      },
      {
        label: "Al Rawabi",
        value: 141
      },
      {
        label: "Al Rawdah",
        value: 142
      },
      {
        label: "Al Rayyan",
        value: 144
      },
      {
        label: "Al Rihab - Al Diriyah",
        value: 5692
      },
      {
        label: "Al Rimal",
        value: 139
      },
      {
        label: "Al Rimayah",
        value: 140
      },
      {
        label: "Al Saadah",
        value: 147
      },
      {
        label: "Al Safa",
        value: 159
      },
      {
        label: "Al Safarat",
        value: 148
      },
      {
        label: "Al Sahafah",
        value: 158
      },
      {
        label: "Al Salam",
        value: 149
      },
      {
        label: "Al Salhiyah",
        value: 157
      },
      {
        label: "Al Sharafiyah",
        value: 154
      },
      {
        label: "Al Sharq",
        value: 5677
      },
      {
        label: "Al Shifa",
        value: 155
      },
      {
        label: "Al Shimaisi",
        value: 156
      },
      {
        label: "al shuhada",
        value: 4037
      },
      {
        label: "Al Sinaiyah",
        value: 160
      },
      {
        label: "Al Sulay",
        value: 150
      },
      {
        label: "Al Sulaymanaya",
        value: 151
      },
      {
        label: "Al Suwaidi",
        value: 4778
      },
      {
        label: "Al Suwaidi Al Gharabi",
        value: 153
      },
      {
        label: "Al Taawun",
        value: 118
      },
      {
        label: "Al Tarif Al Jadid - Al Diriyah",
        value: 5690
      },
      {
        label: "Al Uraija",
        value: 165
      },
      {
        label: "Al Uraija Al Gharbiyah",
        value: 166
      },
      {
        label: "Al Uraija Al Wusta",
        value: 167
      },
      {
        label: "Al Uyaynah",
        value: 4560
      },
      {
        label: "Al Wadi",
        value: 4038
      },
      {
        label: "Al Wahah",
        value: 218
      },
      {
        label: "Al Wisham",
        value: 4758
      },
      {
        label: "Al Wizarat",
        value: 221
      },
      {
        label: "Al Wurud",
        value: 220
      },
      {
        label: "Al Wusaita",
        value: 222
      },
      {
        label: "Al Yamamah",
        value: 226
      },
      {
        label: "Al Yarmuk",
        value: 225
      },
      {
        label: "Al Yasmin",
        value: 224
      },
      {
        label: "Al Zahraa",
        value: 145
      },
      {
        label: "Al Zahrah",
        value: 5685
      },
      {
        label: "Badr",
        value: 230
      },
      {
        label: "Banban",
        value: 5681
      },
      {
        label: "Dahiat Namar",
        value: 4777
      },
      {
        label: "Dhahrat Al Badiaah",
        value: 251
      },
      {
        label: "Dhahrat Laban",
        value: 2570
      },
      {
        label: "Dirab",
        value: 242
      },
      {
        label: "Ghirnatah",
        value: 259
      },
      {
        label: "Ghubairah",
        value: 258
      },
      {
        label: "Hittin",
        value: 236
      },
      {
        label: "Hyt",
        value: 6142
      },
      {
        label: "Imam Muhammad Ibn Saud Islamic University",
        value: 232
      },
      {
        label: "Irqah",
        value: 255
      },
      {
        label: "Ishbiliyah",
        value: 111
      },
      {
        label: "Jabrah",
        value: 234
      },
      {
        label: "Jarir",
        value: 235
      },
      {
        label: "Khashm Al An",
        value: 241
      },
      {
        label: "King Abdul Aziz",
        value: 238
      },
      {
        label: "King Abdullah",
        value: 237
      },
      {
        label: "King Fahd",
        value: 2163
      },
      {
        label: "King Faisal",
        value: 240
      },
      {
        label: "King Khalid International Airport",
        value: 261
      },
      {
        label: "King Saud University",
        value: 233
      },
      {
        label: "Laban",
        value: 5694
      },
      {
        label: "Makal",
        value: 197
      },
      {
        label: "Manfouhah Al Jadidah",
        value: 263
      },
      {
        label: "Manfuhah",
        value: 262
      },
      {
        label: "Namar",
        value: 264
      },
      {
        label: "New Industrial Area",
        value: 410
      },
      {
        label: "Okaz",
        value: 256
      },
      {
        label: "Princess Nourah Bint Abdul Rahman University",
        value: 5684
      },
      {
        label: "Qurtubah",
        value: 260
      },
      {
        label: "Salah Al Din",
        value: 247
      },
      {
        label: "Samhan - Al Diriyah",
        value: 5688
      },
      {
        label: "Shubra",
        value: 246
      },
      {
        label: "Siyah",
        value: 248
      },
      {
        label: "Skirinah",
        value: 243
      },
      {
        label: "Sultanah",
        value: 244
      },
      {
        label: "Taybah",
        value: 250
      },
      {
        label: "Thulaim",
        value: 231
      },
      {
        label: "Tuwaiq",
        value: 249
      },
      {
        label: "Uhud",
        value: 110
      },
      {
        label: "Ulaishah",
        value: 257
      },
      {
        label: "Umm Al Hamam Al Gharbi",
        value: 228
      },
      {
        label: "Umm Al Hamam Al Sharqi",
        value: 227
      },
      {
        label: "Umm Salim",
        value: 229
      },
      {
        label: "Uraid",
        value: 164
      },
      {
        label: "Utaiqah",
        value: 254
      }
    ],
    value: 10
  },
  {
    label: "Sakaka",
    name: "Sakaka",
    type: "group",
    options: [
      {
        label: "Administrative district",
        value: 3691
      },
      {
        label: "Al Amal",
        value: 6207
      },
      {
        label: "Al Andlus",
        value: 6202
      },
      {
        label: "Al Aziziyah",
        value: 3686
      },
      {
        label: "Al Dhiyab",
        value: 6195
      },
      {
        label: "Al Dilaa",
        value: 2933
      },
      {
        label: "Al Faisaliyah",
        value: 3685
      },
      {
        label: "Al Farouq",
        value: 6203
      },
      {
        label: "Al Fayaz",
        value: 6204
      },
      {
        label: "Al Hada",
        value: 6205
      },
      {
        label: "Al Jouf Airport",
        value: 4768
      },
      {
        label: "Al Laqayet",
        value: 3509
      },
      {
        label: "Al Laqayet Al Gadid",
        value: 6206
      },
      {
        label: "Al Maaqlah",
        value: 4636
      },
      {
        label: "Al Mohamadiyah",
        value: 3510
      },
      {
        label: "Al Nafl",
        value: 6196
      },
      {
        label: "Al Oroba",
        value: 4641
      },
      {
        label: "Al Rabwah",
        value: 3518
      },
      {
        label: "Al Rahmaniyah",
        value: 3687
      },
      {
        label: "Al Rawabi",
        value: 6208
      },
      {
        label: "Al Rayan",
        value: 4640
      },
      {
        label: "Al Rwad",
        value: 6198
      },
      {
        label: "Al Salam",
        value: 6199
      },
      {
        label: "Al Shalhoub",
        value: 3519
      },
      {
        label: "Al Shuaib",
        value: 4637
      },
      {
        label: "Al Souq",
        value: 2937
      },
      {
        label: "Al Sulaymaniyah",
        value: 4631
      },
      {
        label: "Al Towair",
        value: 3689
      },
      {
        label: "Al Zafarana",
        value: 6210
      },
      {
        label: "Al Zayd",
        value: 4642
      },
      {
        label: "Al Zohor",
        value: 3688
      },
      {
        label: "Dara Al Jouf",
        value: 5292
      },
      {
        label: "Industrial Area",
        value: 6211
      },
      {
        label: "Industrial Area 1",
        value: 6209
      },
      {
        label: "Janub Al Aroba",
        value: 6200
      },
      {
        label: "Matr",
        value: 6212
      },
      {
        label: "Naif Druze",
        value: 6213
      },
      {
        label: 'Old City "Al Shifa"',
        value: 4632
      },
      {
        label: "Qara",
        value: 4639
      },
      {
        label: "Shamal Al Saghib",
        value: 6201
      },
      {
        label: "Sharq Al Eqlimi",
        value: 3516
      },
      {
        label: "South-West Gara",
        value: 6214
      }
    ],
    value: 11
  },
  {
    label: "Yanbu",
    name: "Yanbu",
    type: "group",
    options: [
      {
        label: "Ain Al Nawa",
        value: 2291
      },
      {
        label: "Al Amarah",
        value: 6452
      },
      {
        label: "Al Asalah",
        value: 6453
      },
      {
        label: "Al Ayoon",
        value: 2284
      },
      {
        label: "Al Azizia",
        value: 2281
      },
      {
        label: "Al Bandar",
        value: 2306
      },
      {
        label: "Al Bathnah",
        value: 2285
      },
      {
        label: "Al Buhairah",
        value: 6463
      },
      {
        label: "Al Dasma",
        value: 6326
      },
      {
        label: "Al Diyar",
        value: 6455
      },
      {
        label: "Al Fahad",
        value: 6457
      },
      {
        label: "Al Faisal",
        value: 2282
      },
      {
        label: "Al Gabrya",
        value: 2303
      },
      {
        label: "Al Hadaiq",
        value: 4343
      },
      {
        label: "Al Hawraa",
        value: 6458
      },
      {
        label: "Al Jabriyah - Industrial area",
        value: 2289
      },
      {
        label: "Al Jamiyah Al Arabiyah",
        value: 6459
      },
      {
        label: "Al Jar",
        value: 6460
      },
      {
        label: "Al Khalid",
        value: 2286
      },
      {
        label: "Al Khurik",
        value: 6315
      },
      {
        label: "Al Maharrah",
        value: 6316
      },
      {
        label: "Al Majid",
        value: 2304
      },
      {
        label: "Al Mashhad",
        value: 4341
      },
      {
        label: "Al Mehan",
        value: 4028
      },
      {
        label: "Al Mushayrif",
        value: 2307
      },
      {
        label: "Al Nahdah",
        value: 2293
      },
      {
        label: "Al Nakheel",
        value: 2283
      },
      {
        label: "Al Nasim",
        value: 6317
      },
      {
        label: "Al Nawah",
        value: 2290
      },
      {
        label: "Al Qad",
        value: 6318
      },
      {
        label: "Al Rabwah",
        value: 6327
      },
      {
        label: "Al Saharij",
        value: 6330
      },
      {
        label: "Al Sawary",
        value: 2294
      },
      {
        label: "Al Sayadah",
        value: 6319
      },
      {
        label: "Al Sharbatli",
        value: 4344
      },
      {
        label: "Al Shati",
        value: 6328
      },
      {
        label: "Al Shoruq",
        value: 6320
      },
      {
        label: "Al Shoruq",
        value: 6321
      },
      {
        label: "Al Soor",
        value: 6323
      },
      {
        label: "Al Subh",
        value: 2292
      },
      {
        label: "Al Sumayri",
        value: 6322
      },
      {
        label: "Al Sumayri - Industrial area",
        value: 2288
      },
      {
        label: "Al Suraif",
        value: 6324
      },
      {
        label: "Al Swyq",
        value: 6329
      },
      {
        label: "Al Takhi",
        value: 2305
      },
      {
        label: "Al Usaylai",
        value: 6325
      },
      {
        label: "Al Zohor",
        value: 6331
      },
      {
        label: "Industrial Zone",
        value: 4015
      },
      {
        label: "Mishrifah",
        value: 4346
      },
      {
        label: "Radwa",
        value: 2287
      },
      {
        label: "Yanbu",
        value: 3025
      },
      {
        label: "Yanbu Airport",
        value: 6454
      }
    ],
    value: 12
  },
  {
    label: "Al Mubarraz",
    name: "Al Mubarraz",
    type: "group",
    options: [
      {
        label: "Ain Nejm",
        value: 6368
      },
      {
        label: "Al Ahsa Downtown",
        value: 6730
      },
      {
        label: "Al Andalus",
        value: 6740
      },
      {
        label: "Al Faisal",
        value: 6371
      },
      {
        label: "Al Faisaliyah",
        value: 6731
      },
      {
        label: "Al Hazm",
        value: 6741
      },
      {
        label: "Al Khars",
        value: 6725
      },
      {
        label: "Al Mubarraz Town",
        value: 6737
      },
      {
        label: "Al Nuzha",
        value: 6738
      },
      {
        label: "Al Otban",
        value: 6734
      },
      {
        label: "Al Qadisiyah",
        value: 6733
      },
      {
        label: "Al Qudaymat",
        value: 6369
      },
      {
        label: "Al Rajhi",
        value: 6726
      },
      {
        label: "Al Rashdiyah",
        value: 6736
      },
      {
        label: "Al Sayaseb",
        value: 6735
      },
      {
        label: "Al Shabi",
        value: 6339
      },
      {
        label: "Al Shuabah",
        value: 6729
      },
      {
        label: "Al Shurofiyah",
        value: 6742
      },
      {
        label: "Al Yahya",
        value: 6739
      },
      {
        label: "Al-Ghassaniya-1",
        value: 6366
      },
      {
        label: "Al-Ghassaniya-2",
        value: 6367
      },
      {
        label: "Ali Al khars and Ahmad Al Shihab",
        value: 6370
      },
      {
        label: "Bo Sahbal",
        value: 6724
      },
      {
        label: "Mahasin",
        value: 6728
      },
      {
        label: "Mahasin Al Baladiyah",
        value: 6727
      },
      {
        label: "National Guard Housing",
        value: 6732
      }
    ],
    value: 13
  },
  {
    label: "Jazan",
    name: "Jazan",
    type: "group",
    options: [
      {
        label: "Airport",
        value: 4269
      },
      {
        label: "Al Arak - Al Karbus",
        value: 3179
      },
      {
        label: "Al Bashair",
        value: 3180
      },
      {
        label: "Al Jabal",
        value: 3181
      },
      {
        label: "Al Nasim",
        value: 3153
      },
      {
        label: "Al Qalaah",
        value: 3175
      },
      {
        label: "Al Rawabi",
        value: 3182
      },
      {
        label: "Al Rawdah",
        value: 3183
      },
      {
        label: "Al Safa",
        value: 3188
      },
      {
        label: "Al Shati",
        value: 3186
      },
      {
        label: "Al Suez",
        value: 3185
      },
      {
        label: "Al Zohur",
        value: 3184
      },
      {
        label: "Ash Shamiyah\t",
        value: 6343
      },
      {
        label: "Jazan Port",
        value: 5974
      },
      {
        label: "Jazan University",
        value: 5975
      },
      {
        label: "Mizhirah",
        value: 5976
      },
      {
        label: "Mokhtat 5",
        value: 3157
      },
      {
        label: "Mokhtat 6",
        value: 5977
      },
      {
        label: "Mokhtat 7",
        value: 5978
      },
      {
        label: "Mokhtat 8",
        value: 5979
      }
    ],
    value: 14
  },
  {
    label: "Al Rass",
    name: "Al Rass",
    type: "group",
    options: [
      {
        label: "Airport",
        value: 3497
      },
      {
        label: "Al Andalus",
        value: 2928
      },
      {
        label: "Al Ehtifalat",
        value: 6382
      },
      {
        label: "Al Houtta",
        value: 2932
      },
      {
        label: "Al Jandal",
        value: 3491
      },
      {
        label: "Al Qadisiyah",
        value: 5389
      },
      {
        label: "Al Rass",
        value: 2911
      },
      {
        label: "Al Rawadah",
        value: 3501
      },
      {
        label: "Al Shanana",
        value: 5392
      },
      {
        label: "Al Shifa",
        value: 3502
      },
      {
        label: "Al Shuhada",
        value: 5247
      },
      {
        label: "Al Tejari",
        value: 3504
      },
      {
        label: "Al Yarmouk",
        value: 3506
      },
      {
        label: "Al Zahra",
        value: 5249
      },
      {
        label: "Industrial Area",
        value: 6384
      },
      {
        label: "King Abdul Aziz",
        value: 3494
      },
      {
        label: "King Faisal",
        value: 3495
      },
      {
        label: "King Khaled",
        value: 3496
      }
    ],
    value: 15
  },
  {
    label: "Turaif",
    name: "Turaif",

    type: "group",
    options: [
      {
        label: "Airport",
        value: 4590
      },
      {
        label: "Al Faisaliyah",
        value: 4583
      },
      {
        label: "Al Gharbia",
        value: 4592
      },
      {
        label: "Al Khaldiyah",
        value: 4579
      },
      {
        label: "Al Mesaadia",
        value: 4580
      },
      {
        label: "Al Oruba",
        value: 4582
      },
      {
        label: "Al Rawabi",
        value: 4581
      },
      {
        label: "Al Salhia",
        value: 4585
      },
      {
        label: "Al Shifa",
        value: 4589
      },
      {
        label: "Al Worud",
        value: 4588
      },
      {
        label: "Al Yarmouk",
        value: 4584
      },
      {
        label: "Sultanah",
        value: 4587
      }
    ],
    value: 16
  },
  {
    label: "Hail",
    name: "Hail",

    type: "group",
    options: [
      {
        label: "Aja",
        value: 4731
      },
      {
        label: "Al Aziziyah",
        value: 3139
      },
      {
        label: "Al Badiah",
        value: 4732
      },
      {
        label: "Al Jamaeyen",
        value: 3131
      },
      {
        label: "Al Khamashia",
        value: 2452
      },
      {
        label: "Al Khraimi",
        value: 6464
      },
      {
        label: "Al Khuzama",
        value: 3144
      },
      {
        label: "Al Madaen",
        value: 6465
      },
      {
        label: "Al Mahattah",
        value: 5279
      },
      {
        label: "Al Masyaf",
        value: 4736
      },
      {
        label: 'Al Matar "AirPort"',
        value: 2455
      },
      {
        label: "Al Muntazah Al Gharbi",
        value: 6466
      },
      {
        label: "Al Muntazah AL Sharqi",
        value: 6144
      },
      {
        label: "Al Muzaabar",
        value: 6145
      },
      {
        label: "Al Nafal",
        value: 6160
      },
      {
        label: "Al Naqrah",
        value: 6161
      },
      {
        label: "Al Nisiyah",
        value: 4738
      },
      {
        label: "Al Rasf",
        value: 6162
      },
      {
        label: "Al Samraa",
        value: 2465
      },
      {
        label: "Al Shabili Al Gharbi",
        value: 6146
      },
      {
        label: "Al Shabili Al Sharqi",
        value: 6148
      },
      {
        label: "Al Shifa",
        value: 2475
      },
      {
        label: "Al Suwayfilah",
        value: 6164
      },
      {
        label: "Al Wada",
        value: 6467
      },
      {
        label: "Al Wadi",
        value: 6149
      },
      {
        label: "Al Warood",
        value: 3151
      },
      {
        label: "Al Wusayta",
        value: 2468
      },
      {
        label: "Al Yasmen",
        value: 3127
      },
      {
        label: "Al Zahra",
        value: 4745
      },
      {
        label: "Al Zibarah",
        value: 2454
      },
      {
        label: "Barzan",
        value: 2457
      },
      {
        label: "Hadri Al Bilad",
        value: 6165
      },
      {
        label: "Industrial Area",
        value: 3149
      },
      {
        label: "Labdah",
        value: 6167
      },
      {
        label: "Maghaydah",
        value: 6168
      },
      {
        label: "Qafar",
        value: 6169
      },
      {
        label: "Sababah",
        value: 2471
      },
      {
        label: "Salah Al Din Al Gharbi",
        value: 6170
      },
      {
        label: "Salah Al Din Al Sharqi",
        value: 6172
      },
      {
        label: "Samah",
        value: 6173
      },
      {
        label: "Sharaf",
        value: 2453
      },
      {
        label: "Sharq Al Mogamaa",
        value: 6175
      },
      {
        label: "Souq Al Mashiyah",
        value: 6174
      },
      {
        label: "TV",
        value: 3142
      }
    ],
    value: 17
  },
  {
    label: "Mecca",
    name: "Mecca",

    type: "group",
    options: [
      {
        label: "Al Adel",
        value: 2331
      },
      {
        label: "Al Andalus",
        value: 6056
      },
      {
        label: "Al Awali",
        value: 6787
      },
      {
        label: "Al Aziziyah",
        value: 2315
      },
      {
        label: "Al Bibyan",
        value: 4259
      },
      {
        label: "Al Buhayrat",
        value: 2827
      },
      {
        label: "Al Dhayafa",
        value: 5344
      },
      {
        label: "Al Faiha",
        value: 5347
      },
      {
        label: "Al Gomom",
        value: 5100
      },
      {
        label: "Al Hagoon",
        value: 5341
      },
      {
        label: "Al Hajlah",
        value: 6051
      },
      {
        label: "Al Hamra",
        value: 3414
      },
      {
        label: "Al Haram Al Macci",
        value: 6045
      },
      {
        label: "Al Hijrah",
        value: 6047
      },
      {
        label: "Al Hindawiyyah",
        value: 4257
      },
      {
        label: "Al iskan",
        value: 2831
      },
      {
        label: "Al Jammeah",
        value: 2319
      },
      {
        label: "Al Jummayzah",
        value: 2330
      },
      {
        label: "Al Kakiyyah",
        value: 2313
      },
      {
        label: "Al Khadra",
        value: 2825
      },
      {
        label: "Al Khalidiyyah",
        value: 2328
      },
      {
        label: "Al Khansa",
        value: 2821
      },
      {
        label: "Al Maabdah",
        value: 2329
      },
      {
        label: "Al Mansour",
        value: 6468
      },
      {
        label: "Al Masfalah",
        value: 2326
      },
      {
        label: "Al Mashaer",
        value: 2321
      },
      {
        label: "Al Morsalat",
        value: 2318
      },
      {
        label: "Al Nassim",
        value: 2322
      },
      {
        label: "Al Nawwariyyah",
        value: 2828
      },
      {
        label: "Al Nuzhah",
        value: 3411
      },
      {
        label: "Al Omra Al Gadida",
        value: 5348
      },
      {
        label: "Al Qararah and Al Naqqa",
        value: 6052
      },
      {
        label: "Al Rasaifahh",
        value: 2832
      },
      {
        label: "Al Rashadiya",
        value: 5143
      },
      {
        label: "Al Rawabi",
        value: 2324
      },
      {
        label: "Al Rawdah",
        value: 2327
      },
      {
        label: "Al Salama",
        value: 6043
      },
      {
        label: "Al Sharai",
        value: 4248
      },
      {
        label: "Al Shawqiyyah",
        value: 2311
      },
      {
        label: "Al Shohda",
        value: 2830
      },
      {
        label: "Al Shubaikah",
        value: 6054
      },
      {
        label: "Al Sulaymaniyah",
        value: 6050
      },
      {
        label: "Al Takwah",
        value: 2325
      },
      {
        label: "Al Tandabawi",
        value: 6053
      },
      {
        label: "Al Taniem",
        value: 2819
      },
      {
        label: "Al Ukayshiyah",
        value: 6057
      },
      {
        label: "Al Usaylah",
        value: 6055
      },
      {
        label: "Al Utaybiyyah",
        value: 2829
      },
      {
        label: "Al Zahir",
        value: 2317
      },
      {
        label: "Al Zahra",
        value: 5346
      },
      {
        label: 'Al Zaidy "Al Takhasosy"',
        value: 5102
      },
      {
        label: "Batha Quraysh",
        value: 3413
      },
      {
        label: "Gorham",
        value: 5339
      },
      {
        label: "Gorham",
        value: 5340
      },
      {
        label: "Jabal Al Nur",
        value: 2826
      },
      {
        label: "Jarwal",
        value: 4260
      },
      {
        label: "King Fahad",
        value: 5342
      },
      {
        label: "Kuday",
        value: 2316
      },
      {
        label: "Oum Al Jood",
        value: 3412
      },
      {
        label: "Reaa Zakher",
        value: 4233
      },
      {
        label: "Sharai Al Mujahidin",
        value: 2312
      },
      {
        label: "Wadi Jalil",
        value: 6049
      },
      {
        label: "Waly Al Ahd",
        value: 6048
      }
    ],
    value: 18
  },
  {
    label: "Al Kharj",
    name: "Al Kharj",

    type: "group",
    options: [
      {
        label: "Al Afja",
        value: 5815
      },
      {
        label: "Al Aliyah",
        value: 5816
      },
      {
        label: "Al Andalus",
        value: 2343
      },
      {
        label: "Al Aziziyah",
        value: 2347
      },
      {
        label: "Al Badiah",
        value: 5150
      },
      {
        label: "Al Barakah",
        value: 2351
      },
      {
        label: "Al Burj",
        value: 2353
      },
      {
        label: "Al Faisaliyah",
        value: 2348
      },
      {
        label: "Al Khalidiyah",
        value: 2346
      },
      {
        label: "Al Khuzama",
        value: 2367
      },
      {
        label: "Al Mansourah",
        value: 2357
      },
      {
        label: "Al Muntazah",
        value: 2342
      },
      {
        label: "Al Munyfiyah",
        value: 2352
      },
      {
        label: "Al Nahdah",
        value: 4610
      },
      {
        label: "Al Nasifah",
        value: 4612
      },
      {
        label: "Al Nuzhah",
        value: 2344
      },
      {
        label: "Al Rafiaa",
        value: 2360
      },
      {
        label: "Al Rashidiyah",
        value: 2356
      },
      {
        label: "Al Rayyan",
        value: 2349
      },
      {
        label: "Al Saadah",
        value: 2384
      },
      {
        label: "Al Safa",
        value: 5199
      },
      {
        label: "Al Sahba",
        value: 5198
      },
      {
        label: "Al Salam",
        value: 2350
      },
      {
        label: "Al Sulaymaniyah",
        value: 3069
      },
      {
        label: "Al Yamamah",
        value: 3076
      },
      {
        label: "Al Zahir",
        value: 2345
      },
      {
        label: "El Safwa",
        value: 5817
      },
      {
        label: "Mishrif",
        value: 5128
      },
      {
        label: "New Industrial Area",
        value: 2385
      },
      {
        label: "Prince Sattam Bin Abdulaziz University",
        value: 5818
      }
    ],
    value: 19
  },
  {
    label: "Al Jubail",
    name: "Al Jubail",

    type: "group",
    options: [
      {
        label: "Al Ahsa",
        value: 2126
      },
      {
        label: "Al Andalus",
        value: 2127
      },
      {
        label: "Al Bahar",
        value: 3292
      },
      {
        label: "Al Dhabab",
        value: 5798
      },
      {
        label: "Al Faiha",
        value: 2129
      },
      {
        label: "Al Faruq",
        value: 2130
      },
      {
        label: "Al Firdous",
        value: 2131
      },
      {
        label: "Al Hamra",
        value: 3057
      },
      {
        label: "Al Hijaz",
        value: 2122
      },
      {
        label: "Al Huwaylat",
        value: 2133
      },
      {
        label: "Al Jawharah",
        value: 5800
      },
      {
        label: "Al Jubail",
        value: 2179
      },
      {
        label: "Al Khaldiyah",
        value: 3059
      },
      {
        label: "Al Khalij",
        value: 2134
      },
      {
        label: "Al Loulou",
        value: 3299
      },
      {
        label: "Al Ola -Jalmudah",
        value: 4036
      },
      {
        label: "Al Orefee Industrial Area",
        value: 5801
      },
      {
        label: "Al Quds",
        value: 2128
      },
      {
        label: "Al Reggah",
        value: 5803
      },
      {
        label: "Al Safa",
        value: 5804
      },
      {
        label: "Al Shati",
        value: 5805
      },
      {
        label: "Al Ventura Compound",
        value: 6333
      },
      {
        label: "Al Wahah",
        value: 4386
      },
      {
        label: "Al Yarmouk",
        value: 5802
      },
      {
        label: "Dareen",
        value: 3294
      },
      {
        label: "First Industrial Area",
        value: 5806
      },
      {
        label: "Industrial Area",
        value: 5797
      },
      {
        label: "Jubail Center area",
        value: 3287
      },
      {
        label: "Makkah",
        value: 2123
      },
      {
        label: "Mardumah",
        value: 5810
      },
      {
        label: "Mutrafiyah",
        value: 5811
      },
      {
        label: "Najd",
        value: 2125
      },
      {
        label: "Riyadh-Jalmudah",
        value: 5809
      },
      {
        label: "Second Industrial Area",
        value: 5812
      },
      {
        label: "Sudair",
        value: 2124
      },
      {
        label: "SWCC",
        value: 5799
      },
      {
        label: "Taibah-Jalmudah",
        value: 5807
      },
      {
        label: "Taif -Jalmudah",
        value: 5813
      },
      {
        label: "Tebah",
        value: 4034
      },
      {
        label: "Third Industrial Area",
        value: 5814
      },
      {
        label: "Yanbu",
        value: 6361
      },
      {
        label: "Yanbu-Jalmudah",
        value: 5808
      }
    ],
    value: 20
  },
  {
    label: "Al Hofuf",
    name: "Al Hofuf",
    type: "group",
    options: [
      {
        label: "Al Ahsa Airport",
        value: 6696
      },
      {
        label: "Al Aziziyah",
        value: 6722
      },
      {
        label: "Al Bandriyah",
        value: 6716
      },
      {
        label: "Al Baserah",
        value: 6717
      },
      {
        label: "Al Fadliyah",
        value: 6718
      },
      {
        label: "Al Ghowaibah",
        value: 6695
      },
      {
        label: "Al Hawra",
        value: 6697
      },
      {
        label: "Al Hoda",
        value: 6350
      },
      {
        label: "Al Iskan Al Aam - Al Khaldyia",
        value: 6715
      },
      {
        label: "Al Jameyeen",
        value: 6709
      },
      {
        label: "Al Khaldiyah",
        value: 6719
      },
      {
        label: 'Al Kout Al Qadeem "Old Kout"',
        value: 6692
      },
      {
        label: "Al Mazrooa",
        value: 6712
      },
      {
        label: "Al Mazrouyah",
        value: 6703
      },
      {
        label: "Al Merqab",
        value: 6714
      },
      {
        label: "Al Moalimeen East",
        value: 6706
      },
      {
        label: "Al Moalimeen West",
        value: 6694
      },
      {
        label: "Al Mohamadiyah",
        value: 6702
      },
      {
        label: "Al Mohandesin",
        value: 6352
      },
      {
        label: "Al Muthallath",
        value: 6723
      },
      {
        label: "Al Naseem",
        value: 6721
      },
      {
        label: "Al Nayfiayah",
        value: 6701
      },
      {
        label: "Al Olya",
        value: 6691
      },
      {
        label: "Al Omairiyah",
        value: 6693
      },
      {
        label: "Al Rabwah",
        value: 6353
      },
      {
        label: "Al Rafaa Al Janubiyah",
        value: 6354
      },
      {
        label: "Al Rafaa Al Shamlia",
        value: 6355
      },
      {
        label: "Al Rawdha",
        value: 6710
      },
      {
        label: "Al Roweidh",
        value: 6698
      },
      {
        label: "Al Ruqaiqah",
        value: 6708
      },
      {
        label: "Al Saihad",
        value: 6699
      },
      {
        label: "Al Salhiyah",
        value: 6720
      },
      {
        label: "Al Salmaniyah North",
        value: 6705
      },
      {
        label: "Al Salmaniyah South",
        value: 6704
      },
      {
        label: "Al Shehabiyah",
        value: 6711
      },
      {
        label: "Al Shorouq",
        value: 6351
      },
      {
        label: "Al Waha",
        value: 6348
      },
      {
        label: "Al Zahrah",
        value: 6700
      },
      {
        label: "Janob Al Hofuf",
        value: 6356
      },
      {
        label: "Janob Mansobi Al Taleem",
        value: 6349
      },
      {
        label: "Juba",
        value: 6713
      },
      {
        label: "king Abdullah Housing Complex",
        value: 6357
      },
      {
        label: "King Fahad",
        value: 6358
      },
      {
        label: "King Faisal University",
        value: 6707
      },
      {
        label: "Latha",
        value: 6359
      },
      {
        label: "Munayfah",
        value: 6360
      }
    ],
    value: 21
  },
  {
    label: "Buraydah",
    name: "Buraydah",

    type: "group",
    options: [
      {
        label: "Al Akhdar",
        value: 5888
      },
      {
        label: "Al Amn",
        value: 2504
      },
      {
        label: "Al Basateen",
        value: 3248
      },
      {
        label: "Al Basr",
        value: 5889
      },
      {
        label: "Al Dhahi",
        value: 2511
      },
      {
        label: "Al Duaysah",
        value: 5886
      },
      {
        label: "Al Fayziyyah",
        value: 2483
      },
      {
        label: "Al Ghadeer",
        value: 5891
      },
      {
        label: "Al Ghamas",
        value: 2510
      },
      {
        label: "Al Hadyiah",
        value: 2481
      },
      {
        label: "Al Hamr",
        value: 5357
      },
      {
        label: "Al Hilal",
        value: 3239
      },
      {
        label: "Al Iskan",
        value: 2480
      },
      {
        label: "Al Janob",
        value: 3456
      },
      {
        label: "Al Jardah",
        value: 3255
      },
      {
        label: "Al Jazirah",
        value: 5897
      },
      {
        label: "Al Khabib",
        value: 5899
      },
      {
        label: "Al Khadr",
        value: 2482
      },
      {
        label: "Al Khuzama",
        value: 5901
      },
      {
        label: "Al Lasaib",
        value: 5904
      },
      {
        label: "Al Manar",
        value: 4389
      },
      {
        label: "Al Merqab",
        value: 5908
      },
      {
        label: "Al Moroj",
        value: 5917
      },
      {
        label: "Al Mowata",
        value: 3227
      },
      {
        label: "Al Muntazah",
        value: 2499
      },
      {
        label: "Al Muraydisiyyah",
        value: 3236
      },
      {
        label: "Al Nafal",
        value: 6462
      },
      {
        label: "Al Nahdah",
        value: 2520
      },
      {
        label: "Al Nakheel",
        value: 5940
      },
      {
        label: "Al Naqaa Al Sharqia",
        value: 2490
      },
      {
        label: "Al Naseem",
        value: 2495
      },
      {
        label: "Al Nassar",
        value: 3240
      },
      {
        label: "Al Ofoq",
        value: 2893
      },
      {
        label: "Al Olyia",
        value: 2492
      },
      {
        label: "Al Qaa Al Bared",
        value: 2501
      },
      {
        label: "Al Qadisiyah",
        value: 3217
      },
      {
        label: "Al Rabawah",
        value: 2489
      },
      {
        label: "Al Rafeaa",
        value: 5238
      },
      {
        label: "Al Rafiah",
        value: 2479
      },
      {
        label: "Al Rawabi",
        value: 2498
      },
      {
        label: "Al Rayan",
        value: 2519
      },
      {
        label: "Al Rehab",
        value: 3234
      },
      {
        label: "Al Sabakh",
        value: 3251
      },
      {
        label: "Al Saddah",
        value: 2496
      },
      {
        label: "Al Safa",
        value: 4392
      },
      {
        label: "Al Safraa",
        value: 2488
      },
      {
        label: "Al Salam",
        value: 4765
      },
      {
        label: "Al Salhiyah",
        value: 5927
      },
      {
        label: "Al Salmyia",
        value: 2507
      },
      {
        label: "Al Saqarat",
        value: 5943
      },
      {
        label: "Al Shafaq",
        value: 5944
      },
      {
        label: "Al Shamas",
        value: 2503
      },
      {
        label: "Al Sheka",
        value: 3484
      },
      {
        label: "Al Worud",
        value: 6436
      },
      {
        label: "Al Wusayti",
        value: 5933
      },
      {
        label: "Al Yarmouk",
        value: 5937
      },
      {
        label: "Al Zarqaa",
        value: 3246
      },
      {
        label: "AL-BISHER",
        value: 4681
      },
      {
        label: "An Nazyah",
        value: 4688
      },
      {
        label: "Diras",
        value: 5953
      },
      {
        label: "Khub Al Akrash",
        value: 3254
      },
      {
        label: "Khub Al Buraydi",
        value: 5954
      },
      {
        label: "Khub Al Jutaili",
        value: 5955
      },
      {
        label: "Khudayra",
        value: 6335
      },
      {
        label: "QASSIM NATIONAL HOSPITAL",
        value: 4687
      },
      {
        label: "Rawaq",
        value: 3245
      },
      {
        label: "SULIMAN ALHABIB",
        value: 4686
      },
      {
        label: "SULTANAH",
        value: 4680
      },
      {
        label: "Wasit",
        value: 3237
      }
    ],
    value: 22
  },
  {
    label: "Khobar",
    name: "Khobar",
    type: "group",
    options: [
      {
        label: "Al Amwaj",
        value: 4404
      },
      {
        label: "Al Andalus",
        value: 5141
      },
      {
        label: "Al Aqiq",
        value: 2403
      },
      {
        label: "Al Aqrabiyah",
        value: 461
      },
      {
        label: "Al Aziziyah",
        value: 6470
      },
      {
        label: "Al Bahar",
        value: 6033
      },
      {
        label: "Al Bandariyah",
        value: 4017
      },
      {
        label: "Al Buhairah",
        value: 6034
      },
      {
        label: "Al Bustan",
        value: 860
      },
      {
        label: "Al Hada",
        value: 4775
      },
      {
        label: "Al Hamra",
        value: 4401
      },
      {
        label: "Al Hizam Al Akhdar",
        value: 4704
      },
      {
        label: "Al Hizam Al Zahabi",
        value: 453
      },
      {
        label: "Al Iskan",
        value: 465
      },
      {
        label: "Al Jawharah",
        value: 859
      },
      {
        label: "Al Jisr",
        value: 467
      },
      {
        label: "Al Kawthar",
        value: 4407
      },
      {
        label: "Al Khobar Al Janubiyah",
        value: 468
      },
      {
        label: "Al Khobar Al Shamalia",
        value: 454
      },
      {
        label: "Al Khour",
        value: 4511
      },
      {
        label: "Al Khuzama",
        value: 5083
      },
      {
        label: "Al Loaloa",
        value: 6037
      },
      {
        label: "Al Maha",
        value: 4405
      },
      {
        label: "Al Murjan",
        value: 4398
      },
      {
        label: "Al Raja",
        value: 4514
      },
      {
        label: "Al Rakah Al Janubiyah",
        value: 457
      },
      {
        label: "Al Rawabi",
        value: 3033
      },
      {
        label: "Al Sahil",
        value: 6031
      },
      {
        label: "Al Sawari",
        value: 6036
      },
      {
        label: "Al Sheraa",
        value: 6035
      },
      {
        label: "Al Sufun",
        value: 4805
      },
      {
        label: "Al Taawun",
        value: 4400
      },
      {
        label: "Al Tahliyah",
        value: 2447
      },
      {
        label: "Al Thuqbah",
        value: 464
      },
      {
        label: "Al Ulaya",
        value: 462
      },
      {
        label: "Al Yarmouk",
        value: 3578
      },
      {
        label: "Corniche",
        value: 4018
      },
      {
        label: "Ibn Sina",
        value: 4402
      },
      {
        label: "Ishbilia",
        value: 4406
      },
      {
        label: "Madinat Al Umal",
        value: 4019
      },
      {
        label: "Qurtoba",
        value: 858
      },
      {
        label: "Sinayiat Al fawaziya",
        value: 6032
      },
      {
        label: "Sinayiat Al Thuqba",
        value: 5140
      },
      {
        label: "Sports City",
        value: 4399
      }
    ],
    value: 23
  },
  {
    label: "Abu Arish",
    name: "Abu Arish",
    type: "group",
    options: [
      {
        label: "Al Andalus",
        value: 5759
      },
      {
        label: "Al Bahakelah",
        value: 5760
      },
      {
        label: "Al Khaldiyah",
        value: 4044
      },
      {
        label: "Al Muhdaj",
        value: 5761
      },
      {
        label: "Al Muraikhiyah",
        value: 5763
      },
      {
        label: "Al Nahdah",
        value: 4046
      },
      {
        label: "Al Nasim",
        value: 4047
      },
      {
        label: "Al Nuzhah",
        value: 4048
      },
      {
        label: "Al Quds",
        value: 4049
      },
      {
        label: "Al Quwaiyah",
        value: 5779
      },
      {
        label: "Al Rabi",
        value: 4050
      },
      {
        label: "Al Rawdah",
        value: 4051
      },
      {
        label: "Al Sadiliyah",
        value: 5772
      },
      {
        label: "Al Safa",
        value: 5773
      },
      {
        label: "Al Salam",
        value: 4052
      },
      {
        label: "Al Ser village",
        value: 5778
      },
      {
        label: "Al Shabitah",
        value: 5764
      },
      {
        label: "Al Uqdah",
        value: 5771
      },
      {
        label: "Al Worud",
        value: 4053
      },
      {
        label: "Al Zohur",
        value: 4054
      },
      {
        label: "Hakimat Abu Arish",
        value: 5774
      },
      {
        label: "Kamirah - Al Badi & Al Qarafi",
        value: 5775
      },
      {
        label: "King Fahad",
        value: 4045
      },
      {
        label: "Qamrah",
        value: 5776
      },
      {
        label: "Qanborah",
        value: 5777
      }
    ],
    value: 24
  },
  {
    label: "Ras Tanura",
    name: "Ras Tanura",

    type: "group",
    options: [
      {
        label: "Al Andalus",
        value: 2119
      },
      {
        label: "Al Danah",
        value: 2114
      },
      {
        label: "Al Faihaa",
        value: 2118
      },
      {
        label: "Al Montazah",
        value: 2115
      },
      {
        label: "Al Naeem",
        value: 2110
      },
      {
        label: "Al Rawdah",
        value: 2111
      },
      {
        label: "Al Zohour",
        value: 2117
      },
      {
        label: "Industrial",
        value: 3017
      },
      {
        label: "Najmah",
        value: 2113
      },
      {
        label: "Qortubah",
        value: 2116
      }
    ],
    value: 25
  },
  {
    label: "Shaqra",
    name: "Shaqra",

    type: "group",
    options: [
      {
        label: "Al Andlus",
        value: 6217
      },
      {
        label: "Al Dawriyat",
        value: 6216
      },
      {
        label: "Al Iskan",
        value: 6218
      },
      {
        label: "Al Nassim",
        value: 5433
      },
      {
        label: "Al Qarah",
        value: 5429
      },
      {
        label: "Al Rahba",
        value: 2940
      },
      {
        label: "Al Rawdah",
        value: 2941
      },
      {
        label: "Al Waqef bel Qra2en",
        value: 3527
      },
      {
        label: "Al Washm",
        value: 3528
      },
      {
        label: "Ghislah",
        value: 3520
      },
      {
        label: "Shaqra",
        value: 2913
      }
    ],
    value: 26
  },
  {
    label: "Al Badayea",
    name: "Al Badayea",

    type: "group",
    options: [
      {
        label: "Al Andlus",
        value: 5824
      },
      {
        label: "AL Asfar",
        value: 5825
      },
      {
        label: "Al Aziziyah",
        value: 5826
      },
      {
        label: "Al Basateen",
        value: 5827
      },
      {
        label: "Al Mustapha",
        value: 5828
      },
      {
        label: "Al Nakhil",
        value: 5837
      },
      {
        label: "Al Olyia",
        value: 5833
      },
      {
        label: "Al Othmaniah",
        value: 5834
      },
      {
        label: "Al Rawadah",
        value: 5829
      },
      {
        label: "Al Rayan",
        value: 5847
      },
      {
        label: "Al Rimmah",
        value: 5840
      },
      {
        label: "Al Salam 1",
        value: 5830
      },
      {
        label: "Al Salam 2",
        value: 5831
      },
      {
        label: "Al Shabrami",
        value: 5841
      },
      {
        label: "Al Taalim",
        value: 5843
      },
      {
        label: "Al Ubaylah",
        value: 5832
      },
      {
        label: "Al Wusta",
        value: 5835
      },
      {
        label: "Al Yasmine",
        value: 5836
      },
      {
        label: "Industrial Area",
        value: 5844
      },
      {
        label: "Ishbilyah",
        value: 5842
      },
      {
        label: "Ramat",
        value: 5845
      },
      {
        label: "Taibah",
        value: 5846
      }
    ],
    value: 27
  },
  {
    label: "Al Ahsa",
    name: "Al Ahsa",
    type: "group",
    options: [
      {
        label: "Al Aqar",
        value: 5793
      },
      {
        label: "Al Battaliyah",
        value: 4410
      },
      {
        label: "Al Dalwah",
        value: 4483
      },
      {
        label: "Al Fodhool",
        value: 4482
      },
      {
        label: "Al Jishah",
        value: 4492
      },
      {
        label: "Al Jubail",
        value: 4488
      },
      {
        label: "Al Mansorah",
        value: 4480
      },
      {
        label: "Al Markaz",
        value: 4493
      },
      {
        label: "Al Mazzawi",
        value: 5795
      },
      {
        label: "Al Munaizilah",
        value: 4491
      },
      {
        label: "Al Mutayrifi",
        value: 4367
      },
      {
        label: "Al Omran",
        value: 4484
      },
      {
        label: "Al Qarah",
        value: 4486
      },
      {
        label: "Al Sabaat",
        value: 3594
      },
      {
        label: "Al Shaharin",
        value: 4487
      },
      {
        label: "Al Shuaba",
        value: 5796
      },
      {
        label: "Al Taraf",
        value: 4478
      },
      {
        label: "Al Teraibel",
        value: 4697
      },
      {
        label: "Al Tuhaimiyah",
        value: 4699
      },
      {
        label: "Al Twaitheer",
        value: 4700
      },
      {
        label: "Bani Maan",
        value: 4489
      },
      {
        label: "Juatha",
        value: 5794
      },
      {
        label: "Madinat Al Jafr",
        value: 3589
      }
    ],
    value: 28
  },
  {
    label: "Taif",
    name: "Taif",
    type: "group",
    options: [
      {
        label: "Al Aqiq",
        value: 2848
      },
      {
        label: "Al Aziziyah",
        value: 6273
      },
      {
        label: "Al Huwaya",
        value: 6274
      },
      {
        label: "Al Karwa",
        value: 2847
      },
      {
        label: "AL Kotbya",
        value: 2851
      },
      {
        label: "Al Mathnah",
        value: 6275
      },
      {
        label: "Al Nasim",
        value: 2850
      },
      {
        label: "Al Qamriah",
        value: 2201
      },
      {
        label: "Al Sharqiyah",
        value: 6279
      },
      {
        label: "Al Taif",
        value: 6280
      },
      {
        label: "Al Waasit",
        value: 6277
      },
      {
        label: "Al Wesam",
        value: 2846
      },
      {
        label: "Aldhas",
        value: 4220
      },
      {
        label: "ALHALKA CHRKYA",
        value: 3557
      },
      {
        label: "ALHALKA GARBYA",
        value: 3558
      },
      {
        label: "Al-masha",
        value: 4216
      },
      {
        label: "Al-Nozha",
        value: 2104
      },
      {
        label: "Al-shrafya",
        value: 4225
      },
      {
        label: "Awda",
        value: 2109
      },
      {
        label: "Central area",
        value: 6281
      },
      {
        label: "FAYSALYA",
        value: 3444
      },
      {
        label: "GAAL",
        value: 3561
      },
      {
        label: "Hawya",
        value: 5046
      },
      {
        label: "Jabra",
        value: 2204
      },
      {
        label: "KHALDYA",
        value: 3563
      },
      {
        label: "MASARA",
        value: 3449
      },
      {
        label: "NAKHB",
        value: 3450
      },
      {
        label: "National Guard",
        value: 5108
      },
      {
        label: "North shuada",
        value: 2102
      },
      {
        label: "RAYAN",
        value: 3566
      },
      {
        label: "Reha",
        value: 6282
      },
      {
        label: "Rehab",
        value: 4223
      },
      {
        label: "Sadad",
        value: 2842
      },
      {
        label: "SALAMA",
        value: 3451
      },
      {
        label: "Shehar Street",
        value: 2100
      },
      {
        label: "Shubra",
        value: 2197
      },
      {
        label: "South shuada",
        value: 2103
      },
      {
        label: "Um al arad",
        value: 4209
      }
    ],
    value: 29
  },
  {
    label: "Unayzah",
    name: "Unayzah",

    type: "group",
    options: [
      {
        label: "Al Ashrafiyyah",
        value: 6264
      },
      {
        label: "Al Awniyyah",
        value: 6265
      },
      {
        label: "Al Badiah",
        value: 3104
      },
      {
        label: "Al Bustan",
        value: 6266
      },
      {
        label: "Al Dulayah",
        value: 3107
      },
      {
        label: "Al Faiha",
        value: 6269
      },
      {
        label: "Al Fakhriyah",
        value: 2925
      },
      {
        label: "Al Faydah",
        value: 6268
      },
      {
        label: "Al Ghabiah",
        value: 6299
      },
      {
        label: "Al Hada",
        value: 2923
      },
      {
        label: "Al Hadiqah",
        value: 6270
      },
      {
        label: "Al Hamra",
        value: 6271
      },
      {
        label: "Al Hufayrah",
        value: 6272
      },
      {
        label: "Al Iskan",
        value: 6267
      },
      {
        label: "Al Janah",
        value: 6283
      },
      {
        label: "Al Jawharah",
        value: 6284
      },
      {
        label: "Al Khalidiyah",
        value: 3112
      },
      {
        label: "Al Manar",
        value: 6285
      },
      {
        label: "Al Masif",
        value: 6286
      },
      {
        label: "Al Matar",
        value: 2926
      },
      {
        label: "Al Mazadah",
        value: 6287
      },
      {
        label: "Al Muhamadiyah District",
        value: 6288
      },
      {
        label: "Al Nuqailiah",
        value: 6295
      },
      {
        label: "Al Qadisiyah",
        value: 6289
      },
      {
        label: "Al Quds",
        value: 6290
      },
      {
        label: "Al Qusor",
        value: 6291
      },
      {
        label: "Al Rahmaniyah",
        value: 6296
      },
      {
        label: "Al Ramuhiyah",
        value: 6293
      },
      {
        label: "Al Rawabi",
        value: 6297
      },
      {
        label: "Al Rawdah",
        value: 3200
      },
      {
        label: "Al Rawghani",
        value: 6298
      },
      {
        label: "Al Rayan",
        value: 6300
      },
      {
        label: "Al Rimal",
        value: 6301
      },
      {
        label: "Al Salam",
        value: 3203
      },
      {
        label: "Al Salhiyah",
        value: 3204
      },
      {
        label: "Al Salhiyat",
        value: 6294
      },
      {
        label: "Al Sharqiyah",
        value: 6303
      },
      {
        label: "Al Shifa",
        value: 2927
      },
      {
        label: "Al Shuraymiyah",
        value: 6304
      },
      {
        label: "Al Suhaymiyah",
        value: 6302
      },
      {
        label: "Al Sulimaniyah",
        value: 3207
      },
      {
        label: "Al Ulaya",
        value: 3117
      },
      {
        label: "Al Wafaa",
        value: 6292
      },
      {
        label: "Al Wahlan",
        value: 3208
      },
      {
        label: "Al Wusta",
        value: 3209
      },
      {
        label: "Ashrafeye",
        value: 5242
      },
      {
        label: "Damshiyah",
        value: 6305
      },
      {
        label: "Feda",
        value: 5245
      },
      {
        label: "Gharb Al Dirah",
        value: 6306
      },
      {
        label: "Hilalah",
        value: 6307
      },
      {
        label: "Industrial Area",
        value: 6308
      },
      {
        label: "Ishbiliyah",
        value: 6309
      },
      {
        label: "King Fahad",
        value: 6310
      },
      {
        label: "King Khalid",
        value: 6311
      },
      {
        label: "Mishrif",
        value: 6312
      },
      {
        label: "Mlilihah",
        value: 3114
      },
      {
        label: "NOZHA",
        value: 3116
      },
      {
        label: "Shekha",
        value: 5240
      },
      {
        label: "Shikhah",
        value: 6313
      },
      {
        label: "Sulaymanye",
        value: 5241
      },
      {
        label: "Sultanah",
        value: 6314
      }
    ],
    value: 30
  },
  {
    label: "Al Qatif",
    name: "Al Qatif",

    type: "group",
    options: [
      {
        label: "Al Awamiyah",
        value: 5895
      },
      {
        label: "Al Badiaa",
        value: 5896
      },
      {
        label: "Al Badiah",
        value: 5898
      },
      {
        label: "Al Bahar",
        value: 6372
      },
      {
        label: "Al Bahari",
        value: 5900
      },
      {
        label: "Al Bawadi",
        value: 5902
      },
      {
        label: "Al Bustan",
        value: 5903
      },
      {
        label: "Al Dababiyah",
        value: 5892
      },
      {
        label: "Al Doij",
        value: 5894
      },
      {
        label: "Al Fath",
        value: 5905
      },
      {
        label: "Al Hussein",
        value: 4308
      },
      {
        label: "Al Jarrari",
        value: 5950
      },
      {
        label: "Al Jazirah",
        value: 2136
      },
      {
        label: "Al Jumaiymah",
        value: 5907
      },
      {
        label: "Al Khamisah",
        value: 2138
      },
      {
        label: "Al Khuwaildiyah",
        value: 5909
      },
      {
        label: "Al Khuzama",
        value: 5911
      },
      {
        label: "Al Kuwaikib",
        value: 4330
      },
      {
        label: "Al Majidiyah",
        value: 2139
      },
      {
        label: "Al Mashtal",
        value: 5912
      },
      {
        label: "Al Murjan",
        value: 5913
      },
      {
        label: "Al Muruj",
        value: 5915
      },
      {
        label: "Al Muzayrae",
        value: 6340
      },
      {
        label: "Al Narjis",
        value: 3622
      },
      {
        label: "Al Nassirah",
        value: 2135
      },
      {
        label: "Al Qalaah",
        value: 5906
      },
      {
        label: "Al Qudaih",
        value: 5916
      },
      {
        label: "Al Rabiah",
        value: 4103
      },
      {
        label: "Al Rawdah",
        value: 5922
      },
      {
        label: "Al Reef",
        value: 5925
      },
      {
        label: "Al Rida",
        value: 5924
      },
      {
        label: "Al Sahil",
        value: 5926
      },
      {
        label: "Al Shahba",
        value: 5929
      },
      {
        label: "Al Shamsiyyah",
        value: 5930
      },
      {
        label: "Al Shariah",
        value: 3627
      },
      {
        label: "Al Shati",
        value: 2140
      },
      {
        label: "Al Shweikah",
        value: 5931
      },
      {
        label: "Al Tawbi",
        value: 5932
      },
      {
        label: "Al Thuraiya",
        value: 5934
      },
      {
        label: "Al Wadih",
        value: 5918
      },
      {
        label: "Al Wahah",
        value: 2143
      },
      {
        label: "Al Wisadah",
        value: 3630
      },
      {
        label: "Al Worud",
        value: 5919
      },
      {
        label: "Al Yaqut",
        value: 5921
      },
      {
        label: "Al Zahra",
        value: 5935
      },
      {
        label: "Al Zarah",
        value: 5936
      },
      {
        label: "Al Zomorod",
        value: 5938
      },
      {
        label: "Bab Al Sab",
        value: 5939
      },
      {
        label: "Badeaa Al Basri",
        value: 5941
      },
      {
        label: "Central area",
        value: 5945
      },
      {
        label: "Halat Mahish",
        value: 5946
      },
      {
        label: "Industrial area",
        value: 5928
      },
      {
        label: "Mousawarah of Al Awamia\t",
        value: 6341
      },
      {
        label: "Om Al Jazm",
        value: 4327
      },
      {
        label: "Shukrallah",
        value: 5947
      },
      {
        label: "Warehouses Area",
        value: 5948
      }
    ],
    value: 31
  },
  {
    label: "Nairyah",
    name: "Nairyah",

    type: "group",
    options: [
      {
        label: "Al Aziziyah",
        value: 2953
      },
      {
        label: "Al Faisaliyah",
        value: 2954
      },
      {
        label: "Al Khalij",
        value: 5210
      },
      {
        label: "Al Muhamadiyah",
        value: 3618
      },
      {
        label: "Al Rabea",
        value: 5209
      },
      {
        label: "Industrial Area",
        value: 5208
      },
      {
        label: "Nairyah",
        value: 6881
      }
    ],
    value: 32
  },
  {
    label: "Rafha",
    name: "Rafha",
    type: "group",
    options: [
      {
        label: "Al Aziziyah",
        value: 4655
      },
      {
        label: "Al Faisaliyah",
        value: 4653
      },
      {
        label: "Al Jumayma",
        value: 4660
      },
      {
        label: "Al Khalidiyah North",
        value: 4658
      },
      {
        label: "Al Khalidiyah South",
        value: 4659
      },
      {
        label: "Al Misadiyah",
        value: 4650
      },
      {
        label: "Al Muhamadiyah",
        value: 4667
      },
      {
        label: "Al Namozagia North",
        value: 4663
      },
      {
        label: "Al Namozagia South",
        value: 4664
      },
      {
        label: "Al Omal",
        value: 4654
      },
      {
        label: "Al Qadisiyah",
        value: 4651
      },
      {
        label: "Al Rawdah",
        value: 4657
      },
      {
        label: "Al Shamali",
        value: 4656
      },
      {
        label: "Al Yarmouk",
        value: 4662
      },
      {
        label: "Industrial Area",
        value: 4665
      }
    ],
    value: 33
  },
  {
    label: "Khamis Mushait",
    name: "Khamis Mushait",
    type: "group",
    options: [
      {
        label: "Al Aziziyah",
        value: 2553
      },
      {
        label: "Al Bawadi",
        value: 2083
      },
      {
        label: "Al Doha",
        value: 6017
      },
      {
        label: "Al Fath",
        value: 6018
      },
      {
        label: "Al Humaylah",
        value: 6019
      },
      {
        label: "Al Irq Al Janubi",
        value: 6020
      },
      {
        label: "Al Irq Al Shamali",
        value: 6021
      },
      {
        label: "Al Iskan",
        value: 4420
      },
      {
        label: "Al Khaldiyah",
        value: 2095
      },
      {
        label: "Al Khazzan",
        value: 2551
      },
      {
        label: "Al Mamurah",
        value: 2548
      },
      {
        label: "Al Mathnah",
        value: 2090
      },
      {
        label: "Al Mazab",
        value: 6022
      },
      {
        label: "Al Mousa",
        value: 2091
      },
      {
        label: "Al Muntazah",
        value: 2550
      },
      {
        label: "Al Nahdah",
        value: 6024
      },
      {
        label: "Al Nakhil",
        value: 2098
      },
      {
        label: "Al Nasim",
        value: 2084
      },
      {
        label: "Al Nuzhah",
        value: 2557
      },
      {
        label: "Al Qafilah",
        value: 2546
      },
      {
        label: "Al Rabie",
        value: 2547
      },
      {
        label: "Al Raqi",
        value: 2088
      },
      {
        label: "Al Rasras",
        value: 3535
      },
      {
        label: "Al Rawdah",
        value: 6025
      },
      {
        label: "Al Sadd",
        value: 2552
      },
      {
        label: "Al Salam",
        value: 3536
      },
      {
        label: "Al Sharafiyah",
        value: 2089
      },
      {
        label: "Al Suqur",
        value: 2554
      },
      {
        label: "Al Tahliyah",
        value: 4423
      },
      {
        label: "Al Waha",
        value: 2092
      },
      {
        label: "Al Wessam",
        value: 6023
      },
      {
        label: "Al Zaytun",
        value: 6030
      },
      {
        label: "Al Zuhur",
        value: 6026
      },
      {
        label: "Atood",
        value: 4460
      },
      {
        label: "Bishat Mushayt",
        value: 2558
      },
      {
        label: "Damak",
        value: 6027
      },
      {
        label: "Khamis Mushait",
        value: 6029
      },
      {
        label: "Khamis Mushait Airport",
        value: 4434
      },
      {
        label: "Qambar",
        value: 4461
      },
      {
        label: "Shubaah",
        value: 4422
      },
      {
        label: "Shukr",
        value: 2556
      },
      {
        label: "Tayyib Al Ism",
        value: 2086
      },
      {
        label: "Umm Sarar",
        value: 2555
      },
      {
        label: "Wadi Ibn Hashbal",
        value: 6792
      },
      {
        label: "Zalalah",
        value: 6028
      }
    ],
    value: 34
  },
  {
    label: "Al Zulfi",
    name: "Al Zulfi",
    type: "group",
    options: [
      {
        label: "Al Aziziyah",
        value: 2942
      },
      {
        label: "Al Faisaliyah",
        value: 6396
      },
      {
        label: "Al Farouk",
        value: 2944
      },
      {
        label: "Al Forqan",
        value: 6398
      },
      {
        label: "Al Khalidiyah",
        value: 6397
      },
      {
        label: "Al Quds",
        value: 2946
      },
      {
        label: "Al Sadiq",
        value: 3531
      },
      {
        label: "Al Salam",
        value: 2945
      },
      {
        label: "Al Sieh",
        value: 2943
      },
      {
        label: "Al Yamamah",
        value: 3532
      },
      {
        label: "Al Yarmouk",
        value: 3533
      },
      {
        label: "Alqah",
        value: 6399
      },
      {
        label: "New Semnan",
        value: 6400
      },
      {
        label: "Samnan",
        value: 3530
      },
      {
        label: "Uraierah",
        value: 6401
      }
    ],
    value: 35
  },
  {
    label: "Ahad Rafidah",
    name: "Ahad Rafidah",
    type: "group",
    options: [
      {
        label: "Al Aziziyah",
        value: 5780
      },
      {
        label: "Al Khalidyah",
        value: 5781
      },
      {
        label: "Al Khalij",
        value: 5782
      },
      {
        label: "Al Laghar",
        value: 5790
      },
      {
        label: "Al Masif",
        value: 5783
      },
      {
        label: "Al Nahdah",
        value: 5784
      },
      {
        label: "Al Raunahah",
        value: 5792
      },
      {
        label: "Al Salamah",
        value: 5785
      },
      {
        label: "Al Salhiyah",
        value: 5786
      },
      {
        label: "Al Worud",
        value: 5788
      },
      {
        label: "Al Zaytoon",
        value: 5787
      },
      {
        label: "Safwan",
        value: 5791
      }
    ],
    value: 36
  },
  {
    label: "Al Bukayriyah",
    name: "Al Bukayriyah",
    type: "group",
    options: [
      {
        label: "Al Aziziyah",
        value: 5745
      },
      {
        label: "Al Baida",
        value: 5746
      },
      {
        label: "Al Balad Al Qadim",
        value: 5747
      },
      {
        label: "Al Bukayriyah",
        value: 5110
      },
      {
        label: "Al Fahad",
        value: 5748
      },
      {
        label: "Al Halaliyah",
        value: 5749
      },
      {
        label: "Al Khalidiyah",
        value: 5754
      },
      {
        label: "Al Rawdah",
        value: 5750
      },
      {
        label: "Al Zahrah",
        value: 3507
      },
      {
        label: "Ibn Khaldun",
        value: 5753
      },
      {
        label: "New Industrial area",
        value: 5751
      }
    ],
    value: 37
  },
  {
    label: "Al Duwadimi",
    name: "Al Duwadimi",
    type: "group",
    options: [
      {
        label: "Al Aziziyya",
        value: 2900
      },
      {
        label: "Al Draa",
        value: 4191
      },
      {
        label: "Al Faisaliyah",
        value: 2904
      },
      {
        label: "Al Harameen",
        value: 3461
      },
      {
        label: "Al iskan",
        value: 4193
      },
      {
        label: "Al Khalidiyah",
        value: 3464
      },
      {
        label: "Al Khalij",
        value: 5770
      },
      {
        label: "Al Nahdah",
        value: 3466
      },
      {
        label: "Al Nozha",
        value: 4192
      },
      {
        label: "Al Quds",
        value: 5765
      },
      {
        label: "Al Rabwah",
        value: 4189
      },
      {
        label: "Al Rawdah",
        value: 5766
      },
      {
        label: "Al Rayan",
        value: 4190
      },
      {
        label: "Al Salam",
        value: 3467
      },
      {
        label: "Al Subnbola",
        value: 3468
      },
      {
        label: "Bader",
        value: 2901
      },
      {
        label: "Hitten",
        value: 3462
      },
      {
        label: "Industrial Area",
        value: 3463
      },
      {
        label: "King Fahad",
        value: 3465
      },
      {
        label: "Masaddah",
        value: 5769
      },
      {
        label: "Mishrefah",
        value: 5768
      }
    ],
    value: 38
  },
  {
    label: "Al Dilam",
    name: "Al Dilam",
    type: "group",
    options: [
      {
        label: "Al Azzar",
        value: 5172
      },
      {
        label: "Al Khaldiyah",
        value: 5174
      },
      {
        label: "Al Muhammadi",
        value: 5163
      },
      {
        label: "Al Muhandiseen",
        value: 5178
      },
      {
        label: "Al Nasriyah",
        value: 5173
      },
      {
        label: "Al Saeedan",
        value: 5165
      },
      {
        label: "Al Sahna",
        value: 5166
      },
      {
        label: "Al Salmaniyah",
        value: 5167
      },
      {
        label: "Al Samari",
        value: 5164
      },
      {
        label: 'Al Zahby "Golden"',
        value: 5177
      },
      {
        label: "Zomaiqah",
        value: 5175
      }
    ],
    value: 39
  },
  {
    label: "Al Mithnab",
    name: "Al Mithnab",
    type: "group",
    options: [
      {
        label: "Al Bustan",
        value: 5399
      },
      {
        label: "Al Judaydah",
        value: 5397
      },
      {
        label: "Al Khaldiyah",
        value: 4286
      },
      {
        label: "Al Khuzama",
        value: 5400
      },
      {
        label: "Al Muntazah",
        value: 5401
      },
      {
        label: "Al- nakil",
        value: 4298
      },
      {
        label: "Al Qadisiyah",
        value: 4287
      },
      {
        label: "Al Rawdah",
        value: 4292
      },
      {
        label: "Al Safraa",
        value: 4288
      },
      {
        label: "Al Salam",
        value: 4285
      },
      {
        label: "Al Salhiyah",
        value: 4290
      },
      {
        label: "Al Wurud",
        value: 5402
      },
      {
        label: "Industrial Area",
        value: 5398
      },
      {
        label: "Om Ushayrah",
        value: 5403
      },
      {
        label: "Qurtubah",
        value: 4294
      }
    ],
    value: 40
  },
  {
    label: "Saihat",
    name: "Saihat",
    type: "group",
    options: [
      {
        label: "Al Dirah",
        value: 2968
      },
      {
        label: "Al Firdaws",
        value: 3334
      },
      {
        label: "Al Ghadir",
        value: 6192
      },
      {
        label: "Al Kawthar",
        value: 2969
      },
      {
        label: "Al Khalij",
        value: 4314
      },
      {
        label: "Al Khisab",
        value: 4319
      },
      {
        label: "Al Khisab",
        value: 4320
      },
      {
        label: "Al Muntazah",
        value: 2974
      },
      {
        label: "Al Nabiyah",
        value: 3055
      },
      {
        label: "Al Nassim",
        value: 6193
      },
      {
        label: "Al Nur",
        value: 3323
      },
      {
        label: "Al Salam",
        value: 2976
      },
      {
        label: "Al Tif",
        value: 6191
      },
      {
        label: "Al Zuhur",
        value: 4097
      },
      {
        label: "Gharb Al Nabiyah",
        value: 2975
      },
      {
        label: "Ghirnatah",
        value: 2137
      },
      {
        label: "Industrial",
        value: 6190
      },
      {
        label: "Qurtobah",
        value: 6194
      }
    ],
    value: 41
  },
  {
    label: "Bishah",
    name: "Bishah",
    type: "group",
    options: [
      {
        label: "Al Fahad",
        value: 6422
      },
      {
        label: "Al Moussa",
        value: 4195
      },
      {
        label: "Gamaa besh",
        value: 3682
      },
      {
        label: "Mokatat besha",
        value: 3683
      }
    ],
    value: 42
  },
  {
    label: "Arar",
    name: "Arar",

    type: "group",
    options: [
      {
        label: "Al Faiisaliyah",
        value: 5311
      },
      {
        label: "Al Jawhra",
        value: 5315
      },
      {
        label: "Al Khalidiya",
        value: 5318
      },
      {
        label: "Al Mosaediyah Al Gharbi",
        value: 6416
      },
      {
        label: "Al Mosaediyah Al Sharqi",
        value: 6417
      },
      {
        label: "Al Mubarakiyah",
        value: 5328
      },
      {
        label: "Al Nassim",
        value: 5308
      },
      {
        label: "Al Nassiriyah",
        value: 5307
      },
      {
        label: "Al Rayyan",
        value: 5313
      },
      {
        label: "Al Rifa",
        value: 6418
      },
      {
        label: "Arar",
        value: 6415
      },
      {
        label: "Badanah",
        value: 5317
      },
      {
        label: "Industrial Area",
        value: 5333
      },
      {
        label: "Mishref",
        value: 5314
      },
      {
        label: "New Industrial area",
        value: 6419
      },
      {
        label: "Old Airport",
        value: 5334
      }
    ],
    value: 43
  },
  {
    label: "Al Qurayyat",
    name: "Al Qurayyat",

    type: "group",
    options: [
      {
        label: "Al Faisalyiah",
        value: 4608
      },
      {
        label: "Al Mattar",
        value: 4599
      },
      {
        label: "Al Qurayyat Airport",
        value: 4598
      },
      {
        label: "Al Rifaa",
        value: 4600
      },
      {
        label: "Ghtai",
        value: 4609
      },
      {
        label: "Hijrat Al Blais",
        value: 4606
      },
      {
        label: "Husaydah",
        value: 4597
      }
    ],
    value: 44
  },
  {
    label: "Dhahran",
    name: "Dhahran",
    type: "group",
    options: [
      {
        label: "Al Haras Al Watani",
        value: 1845
      },
      {
        label: "Al Jamaa",
        value: 3307
      },
      {
        label: "Al Qashlah",
        value: 6039
      },
      {
        label: "Al Qusur",
        value: 4128
      },
      {
        label: "Aramco",
        value: 1816
      },
      {
        label: "Dana Al Janubiyah",
        value: 1813
      },
      {
        label: "Dana Al Shamaliah",
        value: 1812
      },
      {
        label: "Doha Al Janubiyah",
        value: 1815
      },
      {
        label: "Doha Al Shamaliah",
        value: 1814
      },
      {
        label: "Gharb Al Dhahran",
        value: 6038
      },
      {
        label: "Hajar",
        value: 3308
      },
      {
        label: "King Abdulaziz Air Base",
        value: 6040
      },
      {
        label: "King Fahd University of Petroleum and Minerals",
        value: 1817
      },
      {
        label: "Tihamah",
        value: 5261
      }
    ],
    value: 45
  },
  {
    label: "Al Bahah",
    name: "Al Bahah",
    type: "group",
    options: [
      {
        label: "Al Hawayia",
        value: 2194
      },
      {
        label: "Al Zaffeir",
        value: 2182
      },
      {
        label: "Al Zarqaa",
        value: 2195
      },
      {
        label: "Raghdan",
        value: 2183
      }
    ],
    value: 46
  },
  {
    label: "Al Hayathem",
    name: "Al Hayathem",

    type: "group",
    options: [
      {
        label: "Al Hayathem",
        value: 5789
      }
    ],
    value: 47
  },
  {
    label: "Jafr",
    name: "Jafr",

    type: "group",
    options: [
      {
        label: "Jafr",
        value: 5090
      }
    ],
    value: 48
  },
  {
    label: "QASSIM",
    name: "QASSIM",
    type: "group",
    options: [
      {
        label: "Riyadh Al Khabra",
        value: 5509
      }
    ],
    value: 49
  }
];

const bahrainAreas = [
  {
    label: "Bahrain",
    name: "Bahrain",

    type: "group",
    options: [
      { label: "A'ali", value: 1105 },
      { label: "Abu Saiba", value: 1033 },
      { label: "Adhari - Abu-Baham", value: 1072 },
      { label: "Adliya", value: 1013 },
      { label: "Al Bahair", value: 1080 },
      { label: "Al Burhama", value: 1004 },
      { label: "Al Dair", value: 995 },
      { label: "Al Eker", value: 1094 },
      { label: "Al Hajar", value: 1038 },
      { label: "Al Hoora", value: 1009 },
      { label: "Al Janabiyah", value: 1037 },
      { label: "Al Jasra", value: 1036 },
      { label: "Al Lawzi", value: 1049 },
      { label: "Al Maqsha", value: 2393 },
      { label: "Al Markh", value: 1053 },
      { label: "Al Mazrowiah", value: 1129 },
      { label: "Al Musalla", value: 1054 },
      { label: "Al Qadam", value: 1046 },
      { label: "Al Qalah", value: 1048 },
      { label: "Al Qurayyah", value: 1047 },
      { label: "Al Safriyah", value: 1045 },
      { label: "Al Sayh", value: 996 },
      { label: "Alareen", value: 5500 },
      { label: "Alcorniche", value: 1018 },
      { label: "Alfateh", value: 1015 },
      { label: "Alghurayfah", value: 1014 },
      { label: "Alguful", value: 1017 },
      { label: "Alhajiyat", value: 1103 },
      { label: "Alhunayniyah", value: 1112 },
      { label: "AlJuffair", value: 1008 },
      { label: "Alnaim", value: 1020 },
      { label: "Alsalmaniya", value: 1011 },
      { label: "Alsuwayfiyah", value: 1012 },
      { label: "Amwaj", value: 998 },
      { label: "Arad", value: 1002 },
      { label: "Askar", value: 1146 },
      { label: "Askar Alba", value: 5501 },
      { label: "Awali", value: 1147 },
      { label: "Bahrain Bay", value: 5502 },
      { label: "Bahrain Financial Harbour", value: 1862 },
      { label: "Bani Jamra", value: 1058 },
      { label: "Barbar", value: 1057 },
      { label: "Bilad Al Qadeem", value: 1028 },
      { label: "Bu Ashira", value: 1023 },
      { label: "Bu Ghazal", value: 1024 },
      { label: "Bu Kowarah", value: 1086 },
      { label: "Bu Quwah", value: 1059 },
      { label: "Budaiya", value: 1035 },
      { label: "Buri", value: 1060 },
      { label: "Busaiteen", value: 993 },
      { label: "Daih", value: 1041 },
      { label: "Damistan", value: 1067 },
      { label: "Dar Kulaib", value: 1757 },
      { label: "Diplomatic Area", value: 1026 },
      { label: "Diraz", value: 1040 },
      { label: "Diyar Al Muharraq", value: 5503 },
      { label: "Durrat Al Bahrain", value: 1136 },
      { label: "East Riffa", value: 1115 },
      { label: "Galaly", value: 1003 },
      { label: "Halat Naim", value: 1000 },
      { label: "Halat Seltah", value: 999 },
      { label: "Hamala", value: 1056 },
      { label: "Hidd", value: 994 },
      { label: "Hidd Industrial Area", value: 5504 },
      { label: "Hillat Abdul Saleh", value: 1066 },
      { label: "Hoarat A'ali", value: 1104 },
      { label: "Isa Town", value: 1087 },
      { label: "Jannusan", value: 1065 },
      { label: "Jary Al Shaikh", value: 1098 },
      { label: "Jaww", value: 1133 },
      { label: "Jazaair Beach / Bilag Al Jazaair", value: 1131 },
      { label: "Jeblat Hebshi", value: 1061 },
      { label: "Jid Al Haj", value: 1062 },
      { label: "Jid Ali", value: 1100 },
      { label: "Jidhafs", value: 1064 },
      { label: "Jurdab", value: 1081 },
      { label: "Karbabad", value: 1030 },
      { label: "Karranah", value: 1073 },
      { label: "Karzakkan", value: 1074 },
      { label: "Khamis", value: 1039 },
      { label: "Ma`ameer", value: 1084 },
      { label: "Madinat Hamad / Hamad Town", value: 1075 },
      { label: "Mahooz", value: 1019 },
      { label: "Malkiya", value: 1050 },
      { label: "Manama Center", value: 1031 },
      { label: "Maqabah", value: 1076 },
      { label: "Mina Salman", value: 2392 },
      { label: "Muharraq", value: 997 },
      { label: "Nabih Saleh", value: 1027 },
      { label: "North Sehla", value: 1043 },
      { label: "Nuwaidrat", value: 1096 },
      { label: "Qudaibiya", value: 1016 },
      { label: "Ras Rumman", value: 2390 },
      { label: "Reef Island", value: 5506 },
      { label: "Riffa Alshamali / North Riffa", value: 1088 },
      { label: "Riffa Views", value: 1756 },
      { label: "Saar", value: 1068 },
      { label: "Sadad", value: 1070 },
      { label: "Safreh", value: 1142 },
      { label: "Sakhir", value: 1124 },
      { label: "Salihiya", value: 1007 },
      { label: "Salmabad", value: 1097 },
      { label: "Salman City", value: 1052 },
      { label: "Samaheej", value: 1001 },
      { label: "Sanabis", value: 1029 },
      { label: "Sanad", value: 1077 },
      { label: "Sea Front / City Center", value: 1021 },
      { label: "Seef", value: 1006 },
      { label: "Segaya", value: 1010 },
      { label: "Shahrakkan", value: 1069 },
      { label: "Shakhurah", value: 1044 },
      { label: "Sitra Abu Alayash", value: 1093 },
      { label: "Sitra Al Hamriyah / Sitra Mall", value: 1092 },
      { label: "Sitra Al Kharijiya", value: 1101 },
      { label: "Sitra Al Qaryah", value: 1091 },
      { label: "Sitra Industrial Area", value: 1079 },
      { label: "Sitra Mahaza", value: 1085 },
      { label: "Sitra Murqoban", value: 1082 },
      { label: "Sitra Sufala", value: 1090 },
      { label: "Sitra Um Al Baidh", value: 1102 },
      { label: "Sitra Wadiyan", value: 1083 },
      { label: "South Sehla", value: 1042 },
      { label: "Tashan", value: 1071 },
      { label: "Tubli", value: 1089 },
      { label: "Umm Al Hassam", value: 1022 },
      { label: "Wadi AlSail", value: 1119 },
      { label: "West Riffa", value: 1116 },
      { label: "Zallaq", value: 1153 },
      { label: "Zayed Town", value: 1095 },
      { label: "Zinj", value: 1005 }
    ],
    value: 0
  }
];

const uaeAreas = [
  {
    label: "Abu Dhabi",
    name: "Abu Dhabi",
    type: "group",
    options: [
      {
        label: "Abu Dhabi Gate City",
        value: 6484
      },
      {
        label: "Abu Dhabi Hills",
        value: 6485
      },
      {
        label: "Al Adla",
        value: 5600
      },
      {
        label: "Al Aman",
        value: 1434
      },
      {
        label: "Al Bahya",
        value: 1435
      },
      {
        label: "Al Bandar (Al Raha)",
        value: 2060
      },
      {
        label: "Al Dafrah",
        value: 1436
      },
      {
        label: "Al Etihad",
        value: 1439
      },
      {
        label: "Al Falah City",
        value: 1437
      },
      {
        label: "Al Forsan Village (Khalifa- A)",
        value: 6488
      },
      {
        label: "Al Gurum Resort",
        value: 6492
      },
      {
        label: "Al Hosn",
        value: 1438
      },
      {
        label: "Al Karamah",
        value: 1440
      },
      {
        label: "Al Khalidiyah",
        value: 1441
      },
      {
        label: "Al Khubeirah",
        value: 1442
      },
      {
        label: "Al Mafraq",
        value: 1444
      },
      {
        label: "Al Manhal",
        value: 1445
      },
      {
        label: "Al Maqta",
        value: 1446
      },
      {
        label: "Al Markaziyah",
        value: 1448
      },
      {
        label: "Al Markaziyah West",
        value: 1449
      },
      {
        label: "Al Maryah Island",
        value: 4165
      },
      {
        label: "Al Mina",
        value: 1451
      },
      {
        label: "Al Muneera (Al Raha)",
        value: 2059
      },
      {
        label: "Al Muntazah",
        value: 5599
      },
      {
        label: "Al Musalla",
        value: 1453
      },
      {
        label: "Al Mushrif",
        value: 1454
      },
      {
        label: "Al Muzoon",
        value: 1455
      },
      {
        label: "Al Nahyan",
        value: 1456
      },
      {
        label: "Al Raha",
        value: 1490
      },
      {
        label: "Al Rahba",
        value: 1458
      },
      {
        label: "Al Ras Al Akhdar",
        value: 1491
      },
      {
        label: "Al Rayyana (Khalifa- A)",
        value: 6489
      },
      {
        label: "Al Reef",
        value: 1459
      },
      {
        label: "Al Rowdah",
        value: 1461
      },
      {
        label: "Al Ruwais (Western Region)",
        value: 6500
      },
      {
        label: "Al Safarrat",
        value: 1462
      },
      {
        label: "Al Samha",
        value: 1463
      },
      {
        label: "Al Shamkha",
        value: 1464
      },
      {
        label: "Al Shamkha South",
        value: 6487
      },
      {
        label: "Al Shawamekh",
        value: 1465
      },
      {
        label: "Al Wahdah",
        value: 1467
      },
      {
        label: "Al Wathba",
        value: 1763
      },
      {
        label: "Al Zaab",
        value: 1468
      },
      {
        label: "Al Zafranah",
        value: 5619
      },
      {
        label: "Al Zahraa",
        value: 1469
      },
      {
        label: "Al Zeina (Al Raha)",
        value: 2061
      },
      {
        label: "Bain Al Jesrain",
        value: 1471
      },
      {
        label: "Bani Yas East",
        value: 1762
      },
      {
        label: "Bani Yas West",
        value: 6907
      },
      {
        label: "BreakWater",
        value: 1473
      },
      {
        label: "Capital Centre",
        value: 5598
      },
      {
        label: "Dhow Harbour (Al Mina)",
        value: 1500
      },
      {
        label: "Golf Gardens (Khalifa- A)",
        value: 6491
      },
      {
        label: "Hydra Village (Shahama)",
        value: 1475
      },
      {
        label: "Khor Al Bateen",
        value: 1476
      },
      {
        label: "Madinat Khalifa - A",
        value: 1479
      },
      {
        label: "Madinat Khalifa - B",
        value: 1480
      },
      {
        label: "Madinat Khalifa - C",
        value: 1481
      },
      {
        label: "Madinat Zayed",
        value: 1482
      },
      {
        label: "Masdar City",
        value: 1483
      },
      {
        label: "Mohammed Bin Zayed City",
        value: 1484
      },
      {
        label: "Mussafah Industrial city",
        value: 1485
      },
      {
        label: "Mussafah South",
        value: 6494
      },
      {
        label: "New Shahama",
        value: 1486
      },
      {
        label: "Old Bahya",
        value: 6493
      },
      {
        label: "Port Zayed (Al Mina)",
        value: 1499
      },
      {
        label: "Qasr El Bahr",
        value: 2062
      },
      {
        label: "Qasr El Shatie",
        value: 1489
      },
      {
        label: "Reem Island",
        value: 1492
      },
      {
        label: "Saadiyat Island",
        value: 1493
      },
      {
        label: "Sas Al Nakheel (Khalifa- A)",
        value: 6490
      },
      {
        label: "Sas Al Nakhl Island",
        value: 1494
      },
      {
        label: "Shahama",
        value: 1495
      },
      {
        label: "Shakhbout City",
        value: 6486
      },
      {
        label: "Tourist Club Area (Al Zahiya)",
        value: 1496
      },
      {
        label: "Western Region (Madinat Zayed)",
        value: 6499
      },
      {
        label: "Yas Island",
        value: 1498
      },
      {
        label: "Zayed Sports City",
        value: 1443
      }
    ],
    value: 0
  },
  {
    label: "Dubai",
    name: "Dubai",
    type: "group",
    options: [
      {
        label: "Abu Hail",
        value: 1169
      },
      {
        label: "Academic City",
        value: 1170
      },
      {
        label: "Al Awir",
        value: 1171
      },
      {
        label: "Al Bada'a",
        value: 1172
      },
      {
        label: "Al Baraha",
        value: 1173
      },
      {
        label: "Al Barari",
        value: 4057
      },
      {
        label: "Al Barsha 1",
        value: 1174
      },
      {
        label: "Al Barsha 2",
        value: 1175
      },
      {
        label: "Al Barsha 3",
        value: 1176
      },
      {
        label: "Al Barsha South",
        value: 1177
      },
      {
        label: "Al Dhagaya",
        value: 1179
      },
      {
        label: "Al Furjan",
        value: 1181
      },
      {
        label: "Al Garhoud",
        value: 1182
      },
      {
        label: "Al Hamriya",
        value: 1183
      },
      {
        label: "Al Hudaiba",
        value: 1184
      },
      {
        label: "Al Jaddaf",
        value: 1185
      },
      {
        label: "Al Jaffiliya",
        value: 1186
      },
      {
        label: "Al Karama",
        value: 1187
      },
      {
        label: "Al Khabaisi",
        value: 1188
      },
      {
        label: "Al Khawaneej 1",
        value: 4158
      },
      {
        label: "Al Khawaneej 2",
        value: 4159
      },
      {
        label: "Al Mamzar",
        value: 1191
      },
      {
        label: "Al Manara",
        value: 1192
      },
      {
        label: "Al Mankhool",
        value: 1193
      },
      {
        label: "Al Mina",
        value: 1195
      },
      {
        label: "Al Mizhar 1",
        value: 1198
      },
      {
        label: "Al Mizhar 2",
        value: 1199
      },
      {
        label: "Al Muraqqabat",
        value: 1200
      },
      {
        label: "Al Murar",
        value: 1201
      },
      {
        label: "Al Mushrif",
        value: 1202
      },
      {
        label: "Al Muteena",
        value: 1203
      },
      {
        label: "Al Nahda 1",
        value: 1204
      },
      {
        label: "Al Nahda 2",
        value: 1205
      },
      {
        label: "Al Quoz 1",
        value: 1207
      },
      {
        label: "Al Quoz 2",
        value: 1208
      },
      {
        label: "Al Quoz 3",
        value: 1209
      },
      {
        label: "Al Quoz 4",
        value: 1210
      },
      {
        label: "Al Quoz Industrial Area 1",
        value: 1211
      },
      {
        label: "Al Quoz Industrial Area 2",
        value: 1212
      },
      {
        label: "Al Quoz Industrial Area 3",
        value: 1213
      },
      {
        label: "Al Quoz Industrial Area 4",
        value: 1214
      },
      {
        label: "Al Qusais 1",
        value: 1215
      },
      {
        label: "Al Qusais 2",
        value: 1216
      },
      {
        label: "Al Qusais 3",
        value: 1217
      },
      {
        label: "Al Qusais Industrial Area 1",
        value: 1218
      },
      {
        label: "Al Qusais Industrial Area 2",
        value: 1219
      },
      {
        label: "Al Qusais Industrial Area 3",
        value: 1220
      },
      {
        label: "Al Qusais Industrial Area 4",
        value: 1221
      },
      {
        label: "Al Qusais Industrial Area 5",
        value: 1222
      },
      {
        label: "Al Raffa",
        value: 1223
      },
      {
        label: "Al Ras",
        value: 1224
      },
      {
        label: "Al Rashidiya",
        value: 1225
      },
      {
        label: "Al Rigga",
        value: 1226
      },
      {
        label: "Al Sabkha",
        value: 1227
      },
      {
        label: "Al Safa",
        value: 1228
      },
      {
        label: "Al Safa 2",
        value: 1230
      },
      {
        label: "Al Satwa",
        value: 1233
      },
      {
        label: "Al Shindagha",
        value: 1234
      },
      {
        label: "Al Souq Al Kabeer",
        value: 1236
      },
      {
        label: "Al Sufouh 1",
        value: 1231
      },
      {
        label: "Al Sufouh 2",
        value: 1232
      },
      {
        label: "Al Twar 1",
        value: 1237
      },
      {
        label: "Al Twar 2",
        value: 1238
      },
      {
        label: "Al Twar 3",
        value: 1239
      },
      {
        label: "Al Waheda",
        value: 1240
      },
      {
        label: "Al Warqa 1",
        value: 1241
      },
      {
        label: "Al Warqa 2",
        value: 1242
      },
      {
        label: "Al Warqa 3",
        value: 4058
      },
      {
        label: "Al Warqa 4",
        value: 4059
      },
      {
        label: "Al Warqa 5",
        value: 4060
      },
      {
        label: "Al Wasl",
        value: 1244
      },
      {
        label: "Arabian Ranches",
        value: 1246
      },
      {
        label: "Arabian Ranches 2",
        value: 5550
      },
      {
        label: "Arjan",
        value: 6474
      },
      {
        label: "Barsha Heights - TECOM",
        value: 1350
      },
      {
        label: "Bukadra",
        value: 1249
      },
      {
        label: "Business Bay",
        value: 1252
      },
      {
        label: "Corniche Deira",
        value: 1253
      },
      {
        label: "DIFC",
        value: 1256
      },
      {
        label: "Discovery Gardens",
        value: 1257
      },
      {
        label: "Downtown Burj Khalifa",
        value: 1258
      },
      {
        label: "Downtown Jabel Ali",
        value: 1259
      },
      {
        label: "Dubai Airport Freezone",
        value: 1260
      },
      {
        label: "Dubai Cargo Village",
        value: 1261
      },
      {
        label: "Dubai Design District",
        value: 4577
      },
      {
        label: "Dubai Falcon City",
        value: 1262
      },
      {
        label: "Dubai Festival City",
        value: 1263
      },
      {
        label: "Dubai Healthcare City",
        value: 1264
      },
      {
        label: "Dubai International Airport",
        value: 1265
      },
      {
        label: "Dubai Internet City - DIC",
        value: 1266
      },
      {
        label: "Dubai Investments Park 1",
        value: 1268
      },
      {
        label: "Dubai Investments Park 2",
        value: 1269
      },
      {
        label: "Dubai Lifestyle City",
        value: 6784
      },
      {
        label: "Dubai Marina",
        value: 1272
      },
      {
        label: "Dubai Maritime City",
        value: 1273
      },
      {
        label: "Dubai Media City",
        value: 1274
      },
      {
        label: "Dubai Motor City",
        value: 1276
      },
      {
        label: "Dubai Silicon Oasis",
        value: 1277
      },
      {
        label: "Dubai Sports City",
        value: 1278
      },
      {
        label: "Dubai Studio City",
        value: 1349
      },
      {
        label: "Dubai Techno Park",
        value: 1279
      },
      {
        label: "Dubai World Central - DWC",
        value: 4067
      },
      {
        label: "Dubai World Trade Center - DWTC",
        value: 1280
      },
      {
        label: "Emirates Hills",
        value: 1282
      },
      {
        label: "Gardens",
        value: 1283
      },
      {
        label: "Global Village",
        value: 1284
      },
      {
        label: "Green Community",
        value: 1285
      },
      {
        label: "Green Community Motor City",
        value: 4007
      },
      {
        label: "Hor Al Anz",
        value: 1288
      },
      {
        label: "Hor Al Anz East",
        value: 1289
      },
      {
        label: "Ibn Batutta Mall",
        value: 1290
      },
      {
        label: "IMPZ",
        value: 1291
      },
      {
        label: "International City",
        value: 1292
      },
      {
        label: "International City 2",
        value: 6801
      },
      {
        label: "Jebel Ali 1",
        value: 1293
      },
      {
        label: "Jebel Ali 2",
        value: 1294
      },
      {
        label: "Jebel Ali Freezone",
        value: 1295
      },
      {
        label: "Jebel Ali Freezone Extension",
        value: 4061
      },
      {
        label: "Jebel Ali Industrial Area",
        value: 1298
      },
      {
        label: "Jumeirah 1",
        value: 1302
      },
      {
        label: "Jumeirah 2",
        value: 1303
      },
      {
        label: "Jumeirah 3",
        value: 1304
      },
      {
        label: "Jumeirah Beach Residence - JBR",
        value: 1305
      },
      {
        label: "Jumeirah Golf Estates",
        value: 1306
      },
      {
        label: "Jumeirah Heights",
        value: 4009
      },
      {
        label: "Jumeirah Islands",
        value: 1307
      },
      {
        label: "Jumeirah Lakes Towers - JLT",
        value: 1308
      },
      {
        label: "Jumeirah Park",
        value: 2598
      },
      {
        label: "Jumeirah Village Circle - JVC",
        value: 1310
      },
      {
        label: "Jumeirah Village Triangle - JVT",
        value: 1311
      },
      {
        label: "Knowledge Village",
        value: 1270
      },
      {
        label: "Layan Community",
        value: 1312
      },
      {
        label: "Legends",
        value: 6822
      },
      {
        label: "Liwan",
        value: 5553
      },
      {
        label: "Majan",
        value: 6821
      },
      {
        label: "MBR- Al Merkad",
        value: 1194
      },
      {
        label: "Meadows",
        value: 1313
      },
      {
        label: "Meydan South",
        value: 5645
      },
      {
        label: "Mira Community",
        value: 5662
      },
      {
        label: "Mirdif",
        value: 1315
      },
      {
        label: "Mudon",
        value: 5552
      },
      {
        label: "Muhaisnah 1",
        value: 1316
      },
      {
        label: "Muhaisnah 2",
        value: 1317
      },
      {
        label: "Muhaisnah 3",
        value: 2793
      },
      {
        label: "Muhaisnah 4",
        value: 2794
      },
      {
        label: "Nad Al Sheba 1",
        value: 4010
      },
      {
        label: "Nad Al Sheba 2",
        value: 1322
      },
      {
        label: "Nad Al Sheba 3",
        value: 1323
      },
      {
        label: "Nad Al Sheba 4",
        value: 1324
      },
      {
        label: "Nadd Al Hamar",
        value: 1320
      },
      {
        label: "Nadd Al Shamma",
        value: 1321
      },
      {
        label: "Naif",
        value: 1325
      },
      {
        label: "Oud Al Muteena",
        value: 1328
      },
      {
        label: "Oud Metha",
        value: 1329
      },
      {
        label: "Port Rashid",
        value: 1334
      },
      {
        label: "Port Saeed",
        value: 1335
      },
      {
        label: "Ras Al Khor",
        value: 1336
      },
      {
        label: "Ras Al Khor Indsutrial Area 1",
        value: 1337
      },
      {
        label: "Ras Al Khor Indsutrial Area 2",
        value: 1338
      },
      {
        label: "Ras Al Khor Indsutrial Area 3",
        value: 1339
      },
      {
        label: "Remraam",
        value: 2444
      },
      {
        label: "Rigga Al Buteen",
        value: 1340
      },
      {
        label: "Springs",
        value: 1348
      },
      {
        label: "The Greens",
        value: 1286
      },
      {
        label: "The Lakes",
        value: 1281
      },
      {
        label: "The Palm Deira",
        value: 1331
      },
      {
        label: "The Palm Jebel Ali",
        value: 1332
      },
      {
        label: "The Palm Jumeirah",
        value: 1333
      },
      {
        label: "The Skycourts",
        value: 1347
      },
      {
        label: "The Sustainable City",
        value: 5551
      },
      {
        label: "The Villa",
        value: 1352
      },
      {
        label: "Um Al Sheif",
        value: 1353
      },
      {
        label: "Umm Hurair 1",
        value: 2747
      },
      {
        label: "Umm Hurair 2",
        value: 2748
      },
      {
        label: "Umm Ramool",
        value: 1355
      },
      {
        label: "Umm Suqeim 1",
        value: 1357
      },
      {
        label: "Umm Suqeim 2",
        value: 1358
      },
      {
        label: "Umm Suqeim 3",
        value: 1359
      },
      {
        label: "Wadi Alamardi",
        value: 1361
      },
      {
        label: "Warsan 1",
        value: 1363
      },
      {
        label: "Warsan 2",
        value: 1364
      },
      {
        label: "Waterfront",
        value: 1365
      },
      {
        label: "Za'abeel 1",
        value: 1366
      },
      {
        label: "Za'abeel 2",
        value: 1367
      }
    ],
    value: 1
  },
  {
    label: "Sharjah",
    name: "Sharjah",
    type: "group",
    options: [
      {
        label: "Abu Shagara",
        value: 1589
      },
      {
        label: "Al  Muntazah",
        value: 1594
      },
      {
        label: "Al Abar",
        value: 1508
      },
      {
        label: "Al Atain",
        value: 6808
      },
      {
        label: "Al Azra",
        value: 1509
      },
      {
        label: "Al Bataeh",
        value: 5297
      },
      {
        label: "Al Bdai'a Subrub",
        value: 6810
      },
      {
        label: "Al Darari",
        value: 1590
      },
      {
        label: "Al Dhaid",
        value: 5296
      },
      {
        label: "Al Elyash",
        value: 1567
      },
      {
        label: "Al Falah Suburb",
        value: 6811
      },
      {
        label: "Al Falaj",
        value: 1510
      },
      {
        label: "Al Fayha",
        value: 1591
      },
      {
        label: "Al Fisht",
        value: 1511
      },
      {
        label: "Al Ghaphia",
        value: 1512
      },
      {
        label: "Al Gharayen",
        value: 1513
      },
      {
        label: "Al Ghubaiba",
        value: 1515
      },
      {
        label: "Al Ghuwair",
        value: 1516
      },
      {
        label: "Al Goaz",
        value: 1517
      },
      {
        label: "Al Hazana",
        value: 1518
      },
      {
        label: "Al Homaa",
        value: 1593
      },
      {
        label: "Al Jazzat",
        value: 1520
      },
      {
        label: "Al Jubail",
        value: 1521
      },
      {
        label: "Al Juraina",
        value: 1522
      },
      {
        label: "Al Khaledia Suburb",
        value: 1524
      },
      {
        label: "Al Khan",
        value: 1525
      },
      {
        label: "Al Khezamia",
        value: 1526
      },
      {
        label: "Al Layyah",
        value: 1527
      },
      {
        label: "Al Mahatta",
        value: 1528
      },
      {
        label: "Al Majaz 1",
        value: 1530
      },
      {
        label: "Al Majaz 2",
        value: 1531
      },
      {
        label: "Al Majaz 3",
        value: 1532
      },
      {
        label: "Al Mamzar",
        value: 1533
      },
      {
        label: "Al Manakh",
        value: 1534
      },
      {
        label: "Al Manazel",
        value: 6813
      },
      {
        label: "Al Mansura",
        value: 1535
      },
      {
        label: "Al Mareija",
        value: 1536
      },
      {
        label: "Al Mirgab",
        value: 1537
      },
      {
        label: "Al Mujarah",
        value: 1538
      },
      {
        label: "Al Musalla",
        value: 1539
      },
      {
        label: "Al Nabba",
        value: 1595
      },
      {
        label: "Al Nad",
        value: 1544
      },
      {
        label: "Al Nahda",
        value: 1540
      },
      {
        label: "Al Nasserya",
        value: 1541
      },
      {
        label: "Al Nekhailat",
        value: 1542
      },
      {
        label: "Al Noof",
        value: 1543
      },
      {
        label: "Al Qadisia",
        value: 1545
      },
      {
        label: "Al Qasimia",
        value: 1547
      },
      {
        label: "Al Qulayaa",
        value: 4005
      },
      {
        label: "Al Rahmania",
        value: 5596
      },
      {
        label: "Al Ramaqia",
        value: 1549
      },
      {
        label: "Al Ramla East",
        value: 1550
      },
      {
        label: "Al Ramla West",
        value: 1551
      },
      {
        label: "Al Ramtha",
        value: 1552
      },
      {
        label: "Al Rifah",
        value: 1553
      },
      {
        label: "Al Riffa",
        value: 1554
      },
      {
        label: "Al Sabkha",
        value: 1556
      },
      {
        label: "Al Seef",
        value: 1557
      },
      {
        label: "Al Seyouh",
        value: 6780
      },
      {
        label: "Al Shahba",
        value: 1559
      },
      {
        label: "Al Shuwaihen",
        value: 1558
      },
      {
        label: "Al Soor",
        value: 1560
      },
      {
        label: "Al Sweihat",
        value: 1561
      },
      {
        label: "Al Taawun",
        value: 1562
      },
      {
        label: "Al Talaa",
        value: 1596
      },
      {
        label: "Al Tarfa",
        value: 1563
      },
      {
        label: "Al Yarmook",
        value: 1564
      },
      {
        label: "Barashi",
        value: 6809
      },
      {
        label: "Bu Danig",
        value: 1598
      },
      {
        label: "Bu Tina",
        value: 1565
      },
      {
        label: "Dasman",
        value: 1566
      },
      {
        label: "Industrial Area 1",
        value: 1569
      },
      {
        label: "Industrial Area 10",
        value: 4000
      },
      {
        label: "Industrial Area 11",
        value: 4001
      },
      {
        label: "Industrial Area 12",
        value: 4002
      },
      {
        label: "Industrial Area 13",
        value: 4003
      },
      {
        label: "Industrial Area 15",
        value: 2649
      },
      {
        label: "Industrial Area 17",
        value: 2651
      },
      {
        label: "Industrial Area 18",
        value: 2652
      },
      {
        label: "Industrial Area 2",
        value: 1570
      },
      {
        label: "Industrial Area 3",
        value: 1571
      },
      {
        label: "Industrial Area 4",
        value: 1572
      },
      {
        label: "Industrial Area 5",
        value: 1573
      },
      {
        label: "Industrial Area 6",
        value: 1574
      },
      {
        label: "Industrial Area 7",
        value: 1575
      },
      {
        label: "Industrial Area 8",
        value: 1576
      },
      {
        label: "Industrial Area 9",
        value: 3999
      },
      {
        label: "Kalba",
        value: 6794
      },
      {
        label: "Khor Fakkan",
        value: 3894
      },
      {
        label: "Maysaloon",
        value: 1577
      },
      {
        label: "Muwafjah",
        value: 1579
      },
      {
        label: "Muwaileh Commercial",
        value: 1581
      },
      {
        label: "Muzairah",
        value: 6812
      },
      {
        label: "Rolla",
        value: 1583
      },
      {
        label: "Saif Zone",
        value: 1584
      },
      {
        label: "Samnan",
        value: 1585
      },
      {
        label: "Sharqan",
        value: 1586
      },
      {
        label: "Um Altaraffa",
        value: 1599
      },
      {
        label: "University of Sharjah",
        value: 1587
      }
    ],
    value: 2
  },
  {
    label: "Ajman",
    name: "Ajman",
    type: "group",
    options: [
      {
        label: "Ajman City Center",
        value: 1974
      },
      {
        label: "Ajman Corniche",
        value: 1975
      },
      {
        label: "Ajman Free Zone",
        value: 2439
      },
      {
        label: "Ajman Industrial Area 1",
        value: 6782
      },
      {
        label: "Ajman Industrial Area 2",
        value: 6783
      },
      {
        label: "Ajman Pearl",
        value: 1977
      },
      {
        label: "Ajman University",
        value: 2032
      },
      {
        label: "Al Alia",
        value: 6781
      },
      {
        label: "Al Amerah",
        value: 6851
      },
      {
        label: "Al Bahia",
        value: 6852
      },
      {
        label: "Al Bustan",
        value: 1980
      },
      {
        label: "Al Butain",
        value: 1981
      },
      {
        label: "Al Hamidiya",
        value: 1984
      },
      {
        label: "Al Hamidiya 1",
        value: 3968
      },
      {
        label: "Al Hamidiya 2",
        value: 3969
      },
      {
        label: "Al Helio",
        value: 1985
      },
      {
        label: "Al Heliow 1",
        value: 3971
      },
      {
        label: "Al Heliow 2",
        value: 3972
      },
      {
        label: "Al Jurf 1",
        value: 3978
      },
      {
        label: "Al Jurf 2",
        value: 3973
      },
      {
        label: "Al Jurf Industrial Area 1",
        value: 3975
      },
      {
        label: "Al Jurf Industrial Area 2",
        value: 3976
      },
      {
        label: "Al Jurf Industrial Area 3",
        value: 3977
      },
      {
        label: "Al Muntazi 1",
        value: 3995
      },
      {
        label: "Al Muntazi 2",
        value: 3996
      },
      {
        label: "Al Mushairef",
        value: 1988
      },
      {
        label: "Al Mwaihat 1",
        value: 4169
      },
      {
        label: "Al Mwaihat 2",
        value: 4170
      },
      {
        label: "Al Mwaihat 3",
        value: 4171
      },
      {
        label: "Al Nakhil",
        value: 1992
      },
      {
        label: "Al Nakhil 1",
        value: 4172
      },
      {
        label: "Al Nakhil 2",
        value: 4173
      },
      {
        label: "Al Nuaimia 1",
        value: 4174
      },
      {
        label: "Al Nuaimia 2",
        value: 4175
      },
      {
        label: "Al Raqaib 1",
        value: 3997
      },
      {
        label: "Al Raqaib 2",
        value: 3998
      },
      {
        label: "Al Rashidiya 1",
        value: 4177
      },
      {
        label: "Al Rashidiya 2",
        value: 4178
      },
      {
        label: "Al Rashidiya 3",
        value: 4179
      },
      {
        label: "Al Rawda 1 Al Zahraa",
        value: 4180
      },
      {
        label: "Al Rawda 2 Al Zahraa",
        value: 4181
      },
      {
        label: "Al Rawda 3 Al Zahraa",
        value: 6791
      },
      {
        label: "Al Rumailah",
        value: 1998
      },
      {
        label: "Al Tallah 1",
        value: 6853
      },
      {
        label: "Al Tallah 2",
        value: 6854
      },
      {
        label: "Al Yasmeen",
        value: 6850
      },
      {
        label: "Al Zahra",
        value: 2004
      },
      {
        label: "Al Zahya",
        value: 3986
      },
      {
        label: "Al Zawarah",
        value: 2005
      },
      {
        label: "Al Zora",
        value: 2006
      },
      {
        label: "Emirates City",
        value: 2008
      },
      {
        label: "Emirates City Extension",
        value: 2009
      },
      {
        label: "Garden City",
        value: 2010
      },
      {
        label: "Ittihad Village",
        value: 2016
      },
      {
        label: "Masfout",
        value: 2021
      }
    ],
    value: 3
  },
  {
    label: "Umm Al-Quwain",
    name: "Umm Al-Quwain",
    type: "group",
    options: [
      {
        label: "Al Aahad",
        value: 5627
      },
      {
        label: "Al Abrab",
        value: 5620
      },
      {
        label: "Al Dar Al Baidah",
        value: 5639
      },
      {
        label: "Al Haditha",
        value: 5630
      },
      {
        label: "Al Hawiyah",
        value: 5642
      },
      {
        label: "Al Humrah - A",
        value: 5631
      },
      {
        label: "Al Humrah - B",
        value: 5632
      },
      {
        label: "Al Humrah - C",
        value: 5633
      },
      {
        label: "Al Humrah - D",
        value: 5646
      },
      {
        label: "Al Khor",
        value: 5640
      },
      {
        label: "Al Limgadhar",
        value: 5643
      },
      {
        label: "Al Maidan",
        value: 5634
      },
      {
        label: "Al Raas - A",
        value: 5635
      },
      {
        label: "Al Raas - B",
        value: 5636
      },
      {
        label: "Al Raas - C",
        value: 5637
      },
      {
        label: "Al Ramlah",
        value: 5624
      },
      {
        label: "Al Raudah",
        value: 5641
      },
      {
        label: "Al Riqqah",
        value: 5638
      },
      {
        label: "Al Salamah - A",
        value: 5621
      },
      {
        label: "Al Salamah - B",
        value: 5622
      },
      {
        label: "Al Salamah - C",
        value: 5623
      },
      {
        label: "Defence Camp",
        value: 5628
      },
      {
        label: "Green Belt",
        value: 5629
      },
      {
        label: "Industrial Area",
        value: 5625
      },
      {
        label: "Old Town Area",
        value: 5644
      },
      {
        label: "Umm Al Quwain Marina",
        value: 5626
      }
    ],
    value: 4
  },
  {
    label: "Al Ain",
    name: "Al Ain",
    type: "group",
    options: [
      {
        label: "Al Agabiyya",
        value: 1865
      },
      {
        label: "Al Ain International Airport",
        value: 1899
      },
      {
        label: "Al Ain Mall",
        value: 1866
      },
      {
        label: "Al Ain Oasis Villas",
        value: 1867
      },
      {
        label: "Al Ain Zoo",
        value: 6849
      },
      {
        label: "Al Ameriya",
        value: 6845
      },
      {
        label: "Al Bateen",
        value: 1868
      },
      {
        label: "Al Dhahir",
        value: 6498
      },
      {
        label: "Al Foaa",
        value: 1871
      },
      {
        label: "Al Hili",
        value: 1872
      },
      {
        label: "Al Jahili",
        value: 1873
      },
      {
        label: "Al Jimi",
        value: 1874
      },
      {
        label: "Al Khabisi",
        value: 1875
      },
      {
        label: "Al Kuwaitat",
        value: 6496
      },
      {
        label: "Al Maqam",
        value: 1878
      },
      {
        label: "Al Marakhaniya",
        value: 1879
      },
      {
        label: "Al Masoudi",
        value: 1881
      },
      {
        label: "Al Murabaa",
        value: 1938
      },
      {
        label: "Al Muraijeb",
        value: 6842
      },
      {
        label: "Al Mutarad",
        value: 1882
      },
      {
        label: "Al Mutawaa",
        value: 1883
      },
      {
        label: "Al Muwaiji",
        value: 6855
      },
      {
        label: "Al Nabagh",
        value: 6803
      },
      {
        label: "Al Neyadat",
        value: 6495
      },
      {
        label: "Al Qattara",
        value: 1889
      },
      {
        label: "Al Salamat District",
        value: 3944
      },
      {
        label: "Al Sarooj",
        value: 1893
      },
      {
        label: "Al Shabiya",
        value: 1957
      },
      {
        label: "Al Towayya",
        value: 1894
      },
      {
        label: "Al Yahar",
        value: 1895
      },
      {
        label: "Alain Al Fiyada",
        value: 1900
      },
      {
        label: "Asharej",
        value: 1905
      },
      {
        label: "Bedda Bn Ammar",
        value: 1962
      },
      {
        label: "Falaj Hazzaa",
        value: 1913
      },
      {
        label: "Industrial Area",
        value: 1916
      },
      {
        label: "Manazaf",
        value: 1933
      },
      {
        label: "Mezyed",
        value: 6501
      },
      {
        label: "Mubzara",
        value: 1939
      },
      {
        label: "Neima",
        value: 1943
      },
      {
        label: "Tawam",
        value: 1963
      },
      {
        label: "UAE University 1",
        value: 1967
      },
      {
        label: "UAE University 2",
        value: 1968
      },
      {
        label: "Um Ghaffa",
        value: 6497
      },
      {
        label: "Zakher",
        value: 1898
      }
    ],
    value: 5
  },
  {
    label: "Fujairah",
    name: "Fujairah",
    type: "group",
    options: [
      {
        label: "Al Aqah",
        value: 6876
      },
      {
        label: "Al Bedia",
        value: 3859
      },
      {
        label: "Al Buthna",
        value: 3860
      },
      {
        label: "Al Farfar",
        value: 3861
      },
      {
        label: "Al Faseel",
        value: 3862
      },
      {
        label: "Al Gurfa",
        value: 3863
      },
      {
        label: "Al Hala",
        value: 3864
      },
      {
        label: "Al Haray",
        value: 6879
      },
      {
        label: "Al Heel",
        value: 3865
      },
      {
        label: "Al Ittihad",
        value: 3919
      },
      {
        label: "Al Mahatta",
        value: 3866
      },
      {
        label: "Al Owaid",
        value: 3871
      },
      {
        label: "Al Qurayya",
        value: 6878
      },
      {
        label: "Al Taween",
        value: 3877
      },
      {
        label: "Albeledah",
        value: 3879
      },
      {
        label: "Anajaimat",
        value: 3880
      },
      {
        label: "Awhala",
        value: 3881
      },
      {
        label: "Dedna",
        value: 3884
      },
      {
        label: "Dibba",
        value: 3883
      },
      {
        label: "Dibba Al Hosn",
        value: 6872
      },
      {
        label: "Dibba Industrial Area",
        value: 6875
      },
      {
        label: "Fujairah Free Trade Zone",
        value: 3886
      },
      {
        label: "Fujairah Intl Airport",
        value: 3887
      },
      {
        label: "Fujairah Port",
        value: 3888
      },
      {
        label: "Halefaath",
        value: 3890
      },
      {
        label: "Industrial Area",
        value: 3892
      },
      {
        label: "Karsha",
        value: 6874
      },
      {
        label: "Madhab",
        value: 3898
      },
      {
        label: "Masafi",
        value: 3900
      },
      {
        label: "Merashid",
        value: 3902
      },
      {
        label: "Mirbah",
        value: 3899
      },
      {
        label: "Old Fujairah City",
        value: 3904
      },
      {
        label: "Qidfa",
        value: 6877
      },
      {
        label: "Rughaylat",
        value: 3908
      },
      {
        label: "Rumailah",
        value: 3909
      },
      {
        label: "Sakamkam",
        value: 3911
      },
      {
        label: "Sharm",
        value: 3913
      },
      {
        label: "Suwayfah",
        value: 6873
      },
      {
        label: "Zubara",
        value: 6880
      }
    ],
    value: 6
  },
  {
    label: "Ras Al Khaima",
    name: "Ras Al Khaima",
    type: "group",
    options: [
      {
        label: "Al Darbijaniyah",
        value: 6825
      },
      {
        label: "Al Dhait North",
        value: 3920
      },
      {
        label: "Al Dhait South",
        value: 3921
      },
      {
        label: "Al Duhaisah",
        value: 6838
      },
      {
        label: "Al Ghubb",
        value: 6824
      },
      {
        label: "Al Hamra Free Zone",
        value: 2420
      },
      {
        label: "Al Hamra Industrial Area",
        value: 2424
      },
      {
        label: "Al Hamra Island",
        value: 3922
      },
      {
        label: "Al Hamra Village",
        value: 2418
      },
      {
        label: "Al Hudaibah",
        value: 3923
      },
      {
        label: "Al Jazeerah Al Hamra",
        value: 2421
      },
      {
        label: "Al Jesser Area",
        value: 2428
      },
      {
        label: "Al Juwais Area",
        value: 2434
      },
      {
        label: "Al Kharran",
        value: 6837
      },
      {
        label: "Al Mairid",
        value: 2438
      },
      {
        label: "Al Marjan Island",
        value: 2417
      },
      {
        label: "Al Mataf",
        value: 6827
      },
      {
        label: "Al Nadiyah",
        value: 6839
      },
      {
        label: "Al Nakheel Area",
        value: 2429
      },
      {
        label: "Al Nudood",
        value: 6826
      },
      {
        label: "Al Qurm",
        value: 3925
      },
      {
        label: "Al Qusaidat",
        value: 3926
      },
      {
        label: "Al Ragibah",
        value: 6814
      },
      {
        label: "Al Sall",
        value: 3927
      },
      {
        label: "Al Seer",
        value: 3928
      },
      {
        label: "Al Soor",
        value: 6831
      },
      {
        label: "Al Turfah",
        value: 3929
      },
      {
        label: "Al Uraibi",
        value: 2435
      },
      {
        label: "Al Zahra",
        value: 6832
      },
      {
        label: "Burairaat",
        value: 2033
      },
      {
        label: "Dafan Al Khor",
        value: 2427
      },
      {
        label: "Dafan Al Nakheel",
        value: 3930
      },
      {
        label: "Dahan",
        value: 6840
      },
      {
        label: "Digdagga",
        value: 3931
      },
      {
        label: "Ghalilah",
        value: 2035
      },
      {
        label: "Hamrania",
        value: 2036
      },
      {
        label: "Khatt",
        value: 3934
      },
      {
        label: "Khazam",
        value: 2039
      },
      {
        label: "Liwa Badr",
        value: 6833
      },
      {
        label: "Mamoora",
        value: 2040
      },
      {
        label: "Mina Al arab",
        value: 2423
      },
      {
        label: "RAK City",
        value: 6841
      },
      {
        label: "Rams",
        value: 2042
      },
      {
        label: "Ras Al Selaab Area",
        value: 2437
      },
      {
        label: "Refa`ah",
        value: 2422
      },
      {
        label: "Seih Al Ghubb",
        value: 6823
      },
      {
        label: "Seih Al Hudaibah",
        value: 3937
      },
      {
        label: "Seih Al Qusaidat",
        value: 6835
      },
      {
        label: "Seih Al Uraibi",
        value: 2436
      },
      {
        label: "Seih Shihyar",
        value: 6836
      },
      {
        label: "Shamal Haqueel",
        value: 6830
      },
      {
        label: "Shamal Julphar",
        value: 6829
      },
      {
        label: "Shareesha",
        value: 2045
      },
      {
        label: "Sidroh",
        value: 3939
      },
      {
        label: "Suhaim Area",
        value: 2432
      },
      {
        label: "Wadi Ammar",
        value: 6828
      }
    ],
    value: 7
  }
];

const omanAreas = [
  {
    label: "Sur",
    name: "Sur",
    type: "group",
    options: [
      {
        label: " As Ashriya",
        value: 6903
      },
      {
        label: "Al Ayjah",
        value: 5515
      },
      {
        label: "Al Barr",
        value: 2674
      },
      {
        label: "Al Husainiyah",
        value: 5524
      },
      {
        label: "Al Janah",
        value: 6898
      },
      {
        label: "Ar Rashah",
        value: 6901
      },
      {
        label: "Ar Rusagh",
        value: 5519
      },
      {
        label: "As Sabkha",
        value: 6904
      },
      {
        label: "As Sat",
        value: 6902
      },
      {
        label: "Ash Shaabiyah",
        value: 5522
      },
      {
        label: "Billad Suq",
        value: 5513
      },
      {
        label: "Harat Al Balush",
        value: 5525
      },
      {
        label: "Hayy AShurooq",
        value: 6897
      },
      {
        label: "Hillat Al Kahraba",
        value: 5512
      },
      {
        label: "Jabal Al Eid",
        value: 5511
      },
      {
        label: "Makha",
        value: 6900
      },
      {
        label: "Murtafa",
        value: 2678
      },
      {
        label: "Nimah",
        value: 6905
      },
      {
        label: "Nismah",
        value: 5514
      },
      {
        label: "Suq",
        value: 6899
      },
      {
        label: "Sur University College",
        value: 2677
      }
    ],
    value: 0
  },
  {
    label: "Ibra",
    name: "Ibra",
    type: "group",
    options: [
      {
        label: "Aakkab",
        value: 2736
      },
      {
        label: "Al Hazam",
        value: 2730
      },
      {
        label: "Alaya",
        value: 2732
      },
      {
        label: "Ali Humadhi",
        value: 2741
      },
      {
        label: "Haima",
        value: 2671
      },
      {
        label: "Ibra College",
        value: 3052
      },
      {
        label: "Ibra Hospital",
        value: 3053
      },
      {
        label: "Lammaa",
        value: 2733
      },
      {
        label: "Marani",
        value: 2727
      },
      {
        label: "Masroom",
        value: 2673
      },
      {
        label: "Muthanabhi",
        value: 2742
      },
      {
        label: "Mutrid",
        value: 2740
      },
      {
        label: "Muwallah",
        value: 2739
      },
      {
        label: "Naseeb",
        value: 2729
      },
      {
        label: "Safala",
        value: 2737
      },
      {
        label: "Shabiyath",
        value: 2734
      },
      {
        label: "Shahaiafiya",
        value: 2738
      },
      {
        label: "Tabthi",
        value: 2731
      },
      {
        label: "Wadhinam",
        value: 2735
      },
      {
        label: "Yahmadhi",
        value: 2728
      }
    ],
    value: 1
  },
  {
    label: "Saham",
    name: "Saham",

    type: "group",
    options: [
      {
        label: "Abu Zarouz",
        value: 6885
      },
      {
        label: "Al Ghuwaisa",
        value: 6889
      },
      {
        label: "Al Kashi",
        value: 6887
      },
      {
        label: "Al-Haweel",
        value: 6884
      },
      {
        label: "Helet El Rawashed",
        value: 6890
      },
      {
        label: "Majaz Al Sughra",
        value: 6891
      },
      {
        label: "Sahem Heights",
        value: 6888
      },
      {
        label: "Sur Al Shayadi",
        value: 6886
      }
    ],
    value: 2
  },
  {
    label: "Sohar",
    name: "Sohar",
    type: "group",
    options: [
      {
        label: "Afifa",
        value: 2616
      },
      {
        label: "Al Fatik",
        value: 5604
      },
      {
        label: "Al Ghushbah",
        value: 2599
      },
      {
        label: "Al Hadhirah",
        value: 2626
      },
      {
        label: "Al Hambar",
        value: 2612
      },
      {
        label: "Al Hujrah",
        value: 5661
      },
      {
        label: "Al Jufra",
        value: 3671
      },
      {
        label: "Al Khuwayriyyah",
        value: 3673
      },
      {
        label: "Al Multaqa",
        value: 2600
      },
      {
        label: "Al Uwaynat",
        value: 2621
      },
      {
        label: "Al Zafraan",
        value: 2615
      },
      {
        label: "As Sanqar",
        value: 3674
      },
      {
        label: "As Suwayhrah",
        value: 2602
      },
      {
        label: "At Turayf",
        value: 2610
      },
      {
        label: "Awtab",
        value: 2625
      },
      {
        label: "Falaj Al Awhi",
        value: 2614
      },
      {
        label: "Falaj Al Qabail",
        value: 2613
      },
      {
        label: "Ghail Al Shbool",
        value: 6906
      },
      {
        label: "Harat Ash Shaykh",
        value: 4014
      },
      {
        label: "Karwan",
        value: 3669
      },
      {
        label: "Khawr Al Siyabi",
        value: 2622
      },
      {
        label: "Khwar Al Hulu",
        value: 5605
      },
      {
        label: "Majan",
        value: 2623
      },
      {
        label: "Majis",
        value: 2620
      },
      {
        label: "Mina Sohar (Sohar Port)",
        value: 3675
      },
      {
        label: "Sallan",
        value: 2611
      },
      {
        label: "Sohar Sanaiyah",
        value: 2601
      },
      {
        label: "UMQ",
        value: 3670
      }
    ],
    value: 3
  },
  {
    label: "Seeb",
    name: "Seeb",
    type: "group",
    options: [
      {
        label: "Airport Heights",
        value: 5650
      },
      {
        label: "Al Koudh",
        value: 1410
      },
      {
        label: "Al Koudh 6",
        value: 4077
      },
      {
        label: "Al Mawalih North",
        value: 1415
      },
      {
        label: "Al Mawalih South",
        value: 1414
      },
      {
        label: "Hail North",
        value: 1413
      },
      {
        label: "Hail South",
        value: 1412
      },
      {
        label: "Hormuz",
        value: 5137
      },
      {
        label: "Knowledge Oasis Muscat",
        value: 1430
      },
      {
        label: "Maabela North",
        value: 6777
      },
      {
        label: "Maabela South",
        value: 6778
      },
      {
        label: "Muscat Hills",
        value: 2565
      },
      {
        label: "New Airport",
        value: 2688
      },
      {
        label: "Rusayl",
        value: 1417
      },
      {
        label: "Seeb",
        value: 1416
      },
      {
        label: "Sultan Qaboos University",
        value: 2563
      },
      {
        label: "Suq al Seeb",
        value: 1419
      },
      {
        label: "The Wave",
        value: 2566
      }
    ],
    value: 4
  },
  {
    label: "Mussanah",
    name: "Mussanah",
    type: "group",
    options: [
      {
        label: "Al Aees",
        value: 5556
      },
      {
        label: "Al Maghsar",
        value: 5557
      },
      {
        label: "Al Muladdah",
        value: 5558
      },
      {
        label: "Al Orygat",
        value: 5559
      },
      {
        label: "Al Sheeba",
        value: 5560
      },
      {
        label: "Al Tarif",
        value: 5561
      },
      {
        label: "Burj Al Khamis",
        value: 5562
      },
      {
        label: "Musannah",
        value: 5564
      },
      {
        label: "Old Mussanah",
        value: 5563
      },
      {
        label: "Sheeba Al Orygat",
        value: 5565
      }
    ],
    value: 5
  },
  {
    label: "Al Suwayq",
    name: "Al Suwayq",
    type: "group",
    options: [
      {
        label: "ِAl Afrad",
        value: 6795
      },
      {
        label: "Al Hadib",
        value: 6797
      },
      {
        label: "Bath'A Hilal",
        value: 6796
      },
      {
        label: "Suwaiq Fort Area",
        value: 6798
      }
    ],
    value: 6
  },
  {
    label: "Bosher",
    name: "Bosher",
    type: "group",
    options: [
      {
        label: "Al Ansab",
        value: 1382
      },
      {
        label: "Al Azaiba South",
        value: 5601
      },
      {
        label: "Al Ghubra Ash Shamaliyyah",
        value: 1380
      },
      {
        label: "Al Khuwayr North",
        value: 1377
      },
      {
        label: "Al Khuwayr South",
        value: 5651
      },
      {
        label: "Al Qurm 18",
        value: 5652
      },
      {
        label: "Azaiba",
        value: 1381
      },
      {
        label: "Bawshar",
        value: 1376
      },
      {
        label: "Bawsher Heights",
        value: 5653
      },
      {
        label: "Ghala",
        value: 1383
      },
      {
        label: "Ghubrah Janubiyyah",
        value: 1379
      },
      {
        label: "Hay Al Sarooj",
        value: 1603
      },
      {
        label: "Khuwair 33",
        value: 1378
      },
      {
        label: "Madinat Al ِIlam",
        value: 1402
      },
      {
        label: "Madinat Al Sultan Qaboos",
        value: 1401
      },
      {
        label: "Mina al Fahal",
        value: 1409
      },
      {
        label: "Qurm",
        value: 1397
      },
      {
        label: "Qurm 29",
        value: 6799
      },
      {
        label: "Rabia Qurum",
        value: 2683
      },
      {
        label: "Shati Al Qurm",
        value: 1398
      },
      {
        label: "Wattiyah",
        value: 1394
      }
    ],
    value: 7
  },
  {
    label: "Salalah",
    name: "Salalah",

    type: "group",
    options: [
      {
        label: "Al Awqadayn",
        value: 5606
      },
      {
        label: "Al Balid",
        value: 6857
      },
      {
        label: "Al Hafa",
        value: 2579
      },
      {
        label: "Al Hasila",
        value: 2578
      },
      {
        label: "Al Hisn",
        value: 5608
      },
      {
        label: "Al Jadidah",
        value: 6856
      },
      {
        label: "Al Karath",
        value: 5567
      },
      {
        label: "Al Qawf",
        value: 5618
      },
      {
        label: "Al Wadi",
        value: 2573
      },
      {
        label: "Ar Rubat",
        value: 5609
      },
      {
        label: "Awqad Al Janubiyyah",
        value: 2572
      },
      {
        label: "Awqad Ash Shamaliyah",
        value: 2571
      },
      {
        label: "Az Zawiyah",
        value: 5568
      },
      {
        label: "East Salalah",
        value: 5607
      },
      {
        label: "Janub Ad Dahariz",
        value: 5617
      },
      {
        label: "Janub Madinat As Saad",
        value: 5616
      },
      {
        label: "Jarziz",
        value: 5614
      },
      {
        label: "Sahnawt Al Janubiyyah",
        value: 5612
      },
      {
        label: "Salalah Airport (New)",
        value: 2696
      },
      {
        label: "Salalah Gharbiya",
        value: 2694
      },
      {
        label: "Salalah Industrial",
        value: 2698
      },
      {
        label: "Salalah Wosta",
        value: 2699
      },
      {
        label: "Shamal Ad Dahariz",
        value: 5611
      },
      {
        label: "Shamal Madinat As Saadah",
        value: 5613
      },
      {
        label: "Sudh",
        value: 5615
      },
      {
        label: "Umm Al Ghawarif",
        value: 5610
      }
    ],
    value: 8
  },
  {
    label: "Barka",
    name: "Barka",

    type: "group",
    options: [
      {
        label: "Al Basit",
        value: 2631
      },
      {
        label: "Al Maragh",
        value: 2633
      },
      {
        label: "Ar Rumays",
        value: 2638
      },
      {
        label: "Halban",
        value: 2744
      },
      {
        label: "Haradi",
        value: 2640
      },
      {
        label: "Hay Al Salam",
        value: 5554
      },
      {
        label: "Hayy Asim",
        value: 2647
      },
      {
        label: "Muraysi",
        value: 2636
      }
    ],
    value: 9
  },
  {
    label: "Buraimi",
    name: "Buraimi",

    type: "group",
    options: [
      {
        label: "Al Gherifa",
        value: 2706
      },
      {
        label: "Al Helie",
        value: 2715
      },
      {
        label: "Ard ElGaw",
        value: 2707
      },
      {
        label: "Buraimi Industrial",
        value: 2716
      },
      {
        label: "Buraimi University",
        value: 2708
      },
      {
        label: "Hamasa Shaabiyah",
        value: 2709
      },
      {
        label: "Khadrah Al Sieh (New)",
        value: 2710
      },
      {
        label: "Khadrah Qadema (Old)",
        value: 2711
      },
      {
        label: "Mazara Al Aqda",
        value: 5656
      },
      {
        label: "Saraa",
        value: 2751
      }
    ],
    value: 10
  },
  {
    label: "Amerat",
    name: "Amerat",

    type: "group",
    options: [
      {
        label: "Al Hajar",
        value: 2404
      },
      {
        label: "Amarat Phase 1",
        value: 2410
      },
      {
        label: "Amarat Phase 2",
        value: 2411
      },
      {
        label: "Amarat Phase 3",
        value: 2412
      },
      {
        label: "Amarat Phase 4",
        value: 2413
      },
      {
        label: "Amarat Phase 5",
        value: 2414
      },
      {
        label: "Amirat 6",
        value: 5585
      },
      {
        label: "Mahaj",
        value: 2405
      }
    ],
    value: 11
  },
  {
    label: "Rustaq",
    name: "Rustaq",
    type: "group",
    options: [
      {
        label: "Al Hazm",
        value: 5660
      },
      {
        label: "Al Mazahit",
        value: 2588
      },
      {
        label: "Al Midayrah",
        value: 2597
      },
      {
        label: "Al Wishayl",
        value: 2587
      },
      {
        label: "Falaj Al Hadees",
        value: 5658
      }
    ],
    value: 12
  },
  {
    label: "Ibri",
    name: "Ibri",
    type: "group",
    options: [
      {
        label: "Ar Rayibah",
        value: 5593
      },
      {
        label: "Araqi",
        value: 5588
      },
      {
        label: "Dubaishi",
        value: 5591
      },
      {
        label: "Hijjar",
        value: 5586
      },
      {
        label: "Ibri Hospital",
        value: 5589
      },
      {
        label: "Ibri Souq",
        value: 5590
      }
    ],
    value: 13
  },
  {
    label: "Nizwa",
    name: "Nizwa",
    type: "group",
    options: [
      {
        label: "Bahla",
        value: 2666
      },
      {
        label: "Birkat Al Mooz",
        value: 2658
      },
      {
        label: "Falaj Al Daris",
        value: 5657
      },
      {
        label: "Firq",
        value: 2656
      },
      {
        label: "Hay Al Turath North",
        value: 2659
      },
      {
        label: "Hay Al Turath South",
        value: 4689
      },
      {
        label: "Karsha",
        value: 5655
      },
      {
        label: "Karshaa Senaeya (Industrial Area)",
        value: 4691
      },
      {
        label: "Manah",
        value: 2667
      },
      {
        label: "Marfa Dares",
        value: 2663
      },
      {
        label: "Nizwa Suq",
        value: 2655
      },
      {
        label: "Radet Al Bosaidi",
        value: 4692
      },
      {
        label: "Temsa",
        value: 2670
      }
    ],
    value: 14
  },
  {
    label: "Muttrah",
    name: "Muttrah",
    type: "group",
    options: [
      {
        label: "Bait al falaj",
        value: 2686
      },
      {
        label: "CBD",
        value: 1407
      },
      {
        label: "Darsait",
        value: 1403
      },
      {
        label: "Hamriya",
        value: 1404
      },
      {
        label: "Jibrooh",
        value: 1408
      },
      {
        label: "MBD",
        value: 1405
      },
      {
        label: "Muttrah",
        value: 1392
      },
      {
        label: "Ruwi",
        value: 1395
      },
      {
        label: "Wadi Adai",
        value: 1396
      },
      {
        label: "Wadi Al Kabir",
        value: 1406
      }
    ],
    value: 15
  },
  {
    label: "Muscat",
    name: "Muscat",
    type: "group",
    options: [
      {
        label: "Barr al Jissah",
        value: 1431
      },
      {
        label: "Bustan",
        value: 1387
      },
      {
        label: "Helet El Sad",
        value: 2684
      },
      {
        label: "Qantab",
        value: 1388
      },
      {
        label: "Seefah",
        value: 1391
      },
      {
        label: "Yetti",
        value: 1389
      }
    ],
    value: 16
  }
];

const qatarAreas = [
  {
    label: "Doha",
    name: "Doha",
    type: "group",
    options: [
      { label: "Abu Dhalouf", value: 1624 },
      { label: "Abu Hamour", value: 1754 },
      { label: "Abu Samra", value: 1623 },
      { label: "Abu Sidra", value: 1739 },
      { label: "Ain Khaled", value: 1740 },
      { label: "Ain Sinan", value: 1749 },
      { label: "Airport Area - HIA", value: 1720 },
      { label: "Al Asiri", value: 1731 },
      { label: "Al Aziziya", value: 1737 },
      { label: "Al Bidda", value: 1616 },
      { label: "Al Daayen", value: 1746 },
      { label: "Al Dafna", value: 1642 },
      { label: "Al Doha Al Jadeeda", value: 1643 },
      { label: "Al Duhail", value: 1641 },
      { label: "Al Duhail North", value: 3857 },
      { label: "Al Duhail South", value: 3858 },
      { label: "Al Ebaib", value: 1744 },
      { label: "Al Ebb", value: 1647 },
      { label: "Al Egla", value: 1685 },
      { label: "Al Gharrafa", value: 1663 },
      { label: "Al Ghuwairiya", value: 1665 },
      { label: "Al Hilal East", value: 1678 },
      { label: "Al Hilal West", value: 5670 },
      { label: "Al Jasra", value: 1629 },
      { label: "Al Jebailat", value: 1628 },
      { label: "Al Jelaiah", value: 1687 },
      { label: "Al Jerian", value: 1747 },
      { label: "Al Karaana", value: 1667 },
      { label: "Al Kharaitiyat", value: 1631 },
      { label: "Al Kharayej", value: 1742 },
      { label: "Al Kharrara", value: 1630 },
      { label: "Al Khessa", value: 1658 },
      { label: "Al Khor", value: 1637 },
      { label: "Al Khuwair", value: 1640 },
      { label: "Al Luqta", value: 1669 },
      { label: "Al Maamoura", value: 1635 },
      { label: "Al Manaseer", value: 1738 },
      { label: "Al Mansoura", value: 1673 },
      { label: "Al Markhiya", value: 1670 },
      { label: "Al Mashaf", value: 1751 },
      { label: "Al Mearad", value: 6883 },
      { label: "Al Messila", value: 1671 },
      { label: "Al Mirqab", value: 1729 },
      { label: "Al Mirqab Al Jadeed", value: 1652 },
      { label: "Al Muntazah", value: 1725 },
      { label: "Al Murra", value: 1690 },
      { label: "Al Murra East", value: 2388 },
      { label: "Al Murra West", value: 2389 },
      { label: "Al Najada", value: 1676 },
      { label: "Al Nasiriya", value: 1732 },
      { label: "Al Nasr", value: 1653 },
      { label: "Al Nasraniya", value: 1677 },
      { label: "Al Nuaija", value: 1723 },
      { label: "Al Qassar", value: 1666 },
      { label: "Al Rufaa", value: 1728 },
      { label: "Al Rumaila", value: 2440 },
      { label: "Al Ruwais", value: 1648 },
      { label: "Al Sadd", value: 1654 },
      { label: "Al Sailiya", value: 1692 },
      { label: "Al Sakhama", value: 6788 },
      { label: "Al Shamal", value: 1649 },
      { label: "Al Sheehaniya", value: 1656 },
      { label: "Al Soudan", value: 1705 },
      { label: "Al Souq", value: 1655 },
      { label: "Al Thakhira", value: 1645 },
      { label: "Al Thumama", value: 1627 },
      { label: "Al Utouriya", value: 1661 },
      { label: "Al Waab", value: 1689 },
      { label: "Al Wajba", value: 1735 },
      { label: "Al Wakrah", value: 1758 },
      { label: "Al Wukair", value: 1679 },
      { label: "Al Zubara", value: 1657 },
      { label: "Baaya", value: 5580 },
      { label: "Bani Hajar", value: 1664 },
      { label: "Baraht Al Jufairi", value: 1727 },
      { label: "Barwa City", value: 4208 },
      { label: "Barwa Village", value: 3853 },
      { label: "Bin Mahmoud", value: 1707 },
      { label: "Bin Omran", value: 1706 },
      { label: "Bu Nakhla", value: 1714 },
      { label: "Dahl Al Hamam", value: 1717 },
      { label: "Doha Port", value: 1721 },
      { label: "Dukhan", value: 1694 },
      { label: "Education City - Qatar Foundation", value: 3854 },
      { label: "Fereej Abdul Aziz", value: 1708 },
      { label: "Fereej Al Ali", value: 1702 },
      { label: "Fereej Al Ameer", value: 1704 },
      { label: "Fereej Bin Dirham", value: 1674 },
      { label: "Fereej Kulaib", value: 1709 },
      { label: "Fuwairit", value: 1712 },
      { label: "Hamad Medical City", value: 1703 },
      { label: "Hazm Al Markhiya", value: 1693 },
      { label: "Industrial Area", value: 1675 },
      { label: "Izghawa", value: 1733 },
      { label: "Jabal Thuaileb", value: 1683 },
      { label: "Jeryan Najaima", value: 1686 },
      { label: "Land Mark Area", value: 3856 },
      { label: "Legtaifiya - West Bay Lagoon", value: 1701 },
      { label: "Lejmail", value: 1713 },
      { label: "Luaib", value: 3842 },
      { label: "Lusail", value: 1684 },
      { label: "Madinat Al Kaaban", value: 1711 },
      { label: "Madinat Khalifa North", value: 1715 },
      { label: "Madinat Khalifa South", value: 1716 },
      { label: "Mehairja", value: 5581 },
      { label: "Mesaieed", value: 1718 },
      { label: "Mesaieed Industrial Area", value: 1755 },
      { label: "Mesaimeer", value: 1636 },
      { label: "Muaither", value: 1759 },
      { label: "Muaither North", value: 1651 },
      { label: "Muaither South", value: 1691 },
      { label: "Muraikh", value: 1736 },
      { label: "Musheireb", value: 1719 },
      { label: "Najma", value: 1722 },
      { label: "New Al Ghanim", value: 1688 },
      { label: "New Al Hitmi", value: 1730 },
      { label: "New Al Khulaifat", value: 1634 },
      { label: "New Al Rayyan", value: 1668 },
      { label: "New Salata", value: 1625 },
      { label: "Old Airport", value: 1672 },
      { label: "Old Al Ghanim", value: 1662 },
      { label: "Old Al Hitmi", value: 1646 },
      { label: "Old Al Rayyan", value: 1650 },
      { label: "Old Salata", value: 2644 },
      { label: "Onaiza", value: 1700 },
      { label: "Pearl Qatar", value: 1726 },
      { label: "Qatar University", value: 3855 },
      { label: "Ras Abu Abboud", value: 1695 },
      { label: "Ras Abu Fontas", value: 2653 },
      { label: "Rass Laffan", value: 1644 },
      { label: "Rawdat Al Hamam", value: 1699 },
      { label: "Rawdat Al Khail", value: 1696 },
      { label: "Sawda Natheel", value: 1698 },
      { label: "Shagra", value: 1752 },
      { label: "Simaisma", value: 1638 },
      { label: "TinBak", value: 6820 },
      { label: "Um Bab", value: 1680 },
      { label: "Umm Al Amad", value: 1745 },
      { label: "Umm Al Seneem", value: 5582 },
      { label: "Umm Birka", value: 1748 },
      { label: "Umm Garn", value: 5583 },
      { label: "Umm Ghuwailina", value: 1681 },
      { label: "Umm Lekhba", value: 1682 },
      { label: "Umm Obayeria", value: 1633 },
      { label: "Umm Salal Ali", value: 5595 },
      { label: "Umm Salal Mohammed", value: 1750 },
      { label: "Wadi Al Banat", value: 1743 },
      { label: "Wadi Al Sail", value: 1724 },
      { label: "Wadi Lusail", value: 6790 },
      { label: "West Bay", value: 1753 }
    ],
    value: 0
  }
];

const all = [
  { country_code: "kw", list: kuwaitAreas, label: "Kuwait" },
  { country_code: "sa", list: ksaAreas, label: "Saudi Arabia" },
  { country_code: "ae", list: uaeAreas, label: "United Arab Emirates" },
  { country_code: "qa", list: qatarAreas, label: "Qatar" },
  { country_code: "bh", list: bahrainAreas, label: "Bahrain" },
  { country_code: "om", list: omanAreas, label: "Oman" }
];

export default all


// WEBPACK FOOTER //
// ./src/store/data/countries.js